import { ULYSSEUS_INSTITUTIONS_DATA } from "./config/metadata";

export function getKeyFromText(iText){
    const regex = /[^a-z0-9]+/g;
    return iText.toLowerCase().replace(regex, '-')
}

export function getSelectorOptionsFromTextList(iTextList){
    return iTextList.map((itText) => {
        return {
            key: getKeyFromText(itText),
            value: getKeyFromText(itText),
            text: itText
    }
    })
}

export const genreOptions = [
    { key: "m", value: "m", text: "Male" },
    { key: "f", value: "f", text: "Female" },
    { key: "nb", value: "nb", text: "Non binary" },
    { key: "nts", value: "nts", text: "I prefer not to say" },
];

export const languageOptions = getSelectorOptionsFromTextList([
    "English",
    "Spanish",
    "French",
    "Italian",
    "German",
    "Slovakian",
    "Finnish",
    "Montenegrin",
    "Afrikaans",
    "Albanian",
    "Amharic",
    "Arabic",
    "Armenian",
    "Azerbaijani",
    "Basque",
    "Belarusian",
    "Bengali",
    "Bosnian",
    "Bulgarian",
    "Burmese",
    "Catalan",
    "Chinese",
    "Croatian",
    "Czech",
    "Danish",
    "Dutch",
    "Esperanto",
    "Estonian",
    "Filipino",
    "Flemish",
    "Georgian",
    "Greek",
    "Gujarati",
    "Haitian-Creole",
    "Hebrew",
    "Hindi",
    "Hungarian",
    "Icelandic",
    "Indonesian",
    "Irish",
    "Japanese",
    "Javanese",
    "Kannada",
    "Kazakh",
    "Khmer",
    "Korean",
    "Kurdish",
    "Lao",
    "Latvian",
    "Lithuanian",
    "Luxembourgish",
    "Macedonian",
    "Malay",
    "Malayalam",
    "Maltese",
    "Marathi",
    "Mongolian",
    "Nepali",
    "Norwegian",
    "Pashto",
    "Persian",
    "Polish",
    "Portuguese",
    "Punjabi",
    "Romanian",
    "Russian",
    "Serbian",
    "Sinhala",
    "Slovenian",
    "Swahili",
    "Swedish",
    "Tamil",
    "Telugu",
    "Thai",
    "Turkish",
    "Ukrainian",
    "Urdu",
    "Uzbek",
    "Vietnamese",
    "Welsh",
    "Yiddish",
    "Yoruba"
]);

export const levelOptionsDict = {
    beginners_level: "Beginners level",
    intermediate_level: "Intermediate level",
    advanced_level: "Advanced level",
    mother_tongue: "Mother tongue"
};

export const levelOptions = Object.entries(levelOptionsDict).map(
    (itEntry) => {
        let itKey = itEntry[0];
        let itValue = itEntry[1];
        return {
            key: itKey,
            value: itKey,
            text: itValue,
        }
    });

export const universityOptions = ULYSSEUS_INSTITUTIONS_DATA.map((u) => {
    return { key: u.shortName, value: u.shortName, text: u.name };
});

export const identifyOptions = [
    { key: "researcher", value: "researcher", text: "Researcher" },
    {
        key: "teacher_lecturer",
        value: "teacher_lecturer",
        text: "Teacher/Lecturer",
    },
    {
        key: "ulysseus_staff",
        value: "ulysseus_staff",
        text: "Ulysseus staff",
    },
];

export const careerStageOptions = [
    { key: "r1", value: "r1", text: "R1 - First Stage Researcher" },
    { key: "r2", value: "r2", text: "R2 - Recognised Researcher" },
    { key: "r3", value: "r3", text: "R3 - Established Researcher" },
    { key: "r4", value: "r4", text: "R4 - Leading Researcher" },
    { key: "na", value: "na", text: "Not applicable" },
];

export const investigatorYourResearchGroupOptions = [
    {
        key: "adelaida-hermoso-mellado-damas",
        value: "adelaida-hermoso-mellado-damas",
        text: "Adelaida Hermoso Mellado-Damas",
    },
    {
        key: "agnes-festre",
        value: "agnes-festre",
        text: "Agnès Festré",
    },
    {
        key: "aguilar-morante-diana",
        value: "aguilar-morante-diana",
        text: "AGUILAR MORANTE DIANA",
    },
    {
        key: "agustin-riscos-nunez",
        value: "agustin-riscos-nunez",
        text: "Agustín Riscos Núñez",
    },
    {
        key: "alamaki-ari",
        value: "alamaki-ari",
        text: "Alamäki Ari",
    },
    {
        key: "alarcon-de-la-lastra-romero-catalina",
        value: "alarcon-de-la-lastra-romero-catalina",
        text: "alarcon de la Lastra Romero, Catalina",
    },
    {
        key: "alba-fernandez-nicolas-de",
        value: "alba-fernandez-nicolas-de",
        text: "ALBA FERNANDEZ NICOLAS DE",
    },
    {
        key: "alba-maria-d",
        value: "alba-maria-d",
        text: "Alba, María D.",
    },
    {
        key: "alberto-j-molina-cantero",
        value: "alberto-j-molina-cantero",
        text: "Alberto  J. Molina Cantero",
    },
    {
        key: "alberto-quagli",
        value: "alberto-quagli",
        text: "Alberto Quagli",
    },
    {
        key: "alcaide-fernandez-joaquin",
        value: "alcaide-fernandez-joaquin",
        text: "Alcaide Fernández, Joaquín",
    },
    {
        key: "alessio-tei",
        value: "alessio-tei",
        text: "ALESSIO TEI",
    },
    {
        key: "alfonso-garcia-morales",
        value: "alfonso-garcia-morales",
        text: "Alfonso García Morales",
    },
    {
        key: "alfonso-javier-garcia-gonzalez",
        value: "alfonso-javier-garcia-gonzalez",
        text: "Alfonso Javier Garcia Gonzalez",
    },
    {
        key: "alonso-carrillo-alicia",
        value: "alonso-carrillo-alicia",
        text: "ALONSO CARRILLO ALICIA",
    },
    {
        key: "alvarez-garcia-juan-antonio",
        value: "alvarez-garcia-juan-antonio",
        text: "ALVAREZ GARCIA JUAN ANTONIO",
    },
    {
        key: "amalia-luque-sendra",
        value: "amalia-luque-sendra",
        text: "Amalia Luque Sendra",
    },
    {
        key: "ana-m-camean",
        value: "ana-m-camean",
        text: "Ana M. Cameán",
    },
    {
        key: "ana-rivero-garcia",
        value: "ana-rivero-garcia",
        text: "Ana Rivero García",
    },
    {
        key: "analisis-funcional-no-lineal---fqm-127",
        value: "analisis-funcional-no-lineal---fqm-127",
        text: "Análisis Funcional no Lineal - FQM 127",
    },
    {
        key: "anaya-martin-miguel",
        value: "anaya-martin-miguel",
        text: "ANAYA MARTIN MIGUEL",
    },
    {
        key: "andreas-heuer",
        value: "andreas-heuer",
        text: "Andreas Heuer",
    },
    {
        key: "andres-luque-teruel",
        value: "andres-luque-teruel",
        text: "Andrés Luque Teruel",
    },
    {
        key: "anibal-ollero",
        value: "anibal-ollero",
        text: "Anibal Ollero",
    },
    {
        key: "anton-civit",
        value: "anton-civit",
        text: "Antón Civit",
    },
    {
        key: "antonio-ayala",
        value: "antonio-ayala",
        text: "Antonio Ayala",
    },
    {
        key: "antonio-barbucci",
        value: "antonio-barbucci",
        text: "Antonio Barbucci",
    },
    {
        key: "antonio-benitez-burraco",
        value: "antonio-benitez-burraco",
        text: "Antonio Benítez-Burraco",
    },
    {
        key: "antonio-fernandez-espinosa",
        value: "antonio-fernandez-espinosa",
        text: "Antonio Fernández Espinosa",
    },
    {
        key: "antonio-gamiz-gordo",
        value: "antonio-gamiz-gordo",
        text: "Antonio Gamiz-Gordo",
    },
    {
        key: "antonio-gomez-exposito",
        value: "antonio-gomez-exposito",
        text: "Antonio Gómez Expósito",
    },
    {
        key: "antonio-guerrero",
        value: "antonio-guerrero",
        text: "Antonio Guerrero",
    },
    {
        key: "antonio-paul",
        value: "antonio-paul",
        text: "Antonio Paul",
    },
    {
        key: "antonio-sgorbissa",
        value: "antonio-sgorbissa",
        text: "Antonio Sgorbissa",
    },
    {
        key: "antonio-torralba",
        value: "antonio-torralba",
        text: "Antonio Torralba",
    },
    {
        key: "antonio-ventosa-ucero",
        value: "antonio-ventosa-ucero",
        text: "Antonio Ventosa Ucero",
    },
    {
        key: "arias-sanchez-samuel",
        value: "arias-sanchez-samuel",
        text: "Arias Sánchez, Samuel",
    },
    {
        key: "arriaga-florez-mercedes",
        value: "arriaga-florez-mercedes",
        text: "ARRIAGA FLOREZ MERCEDES",
    },
    {
        key: "aunimo-lili",
        value: "aunimo-lili",
        text: "Aunimo Lili",
    },
    {
        key: "aurea-munoz",
        value: "aurea-munoz",
        text: "Áurea Munoz",
    },
    {
        key: "aurea-simon-soro",
        value: "aurea-simon-soro",
        text: "Aurea Simon Soro",
    },
    {
        key: "baca-martin",
        value: "baca-martin",
        text: "Bača Martin",
    },
    {
        key: "beatriz-dominguez-garcia",
        value: "beatriz-dominguez-garcia",
        text: "Beatriz Dominguez Garcia",
    },
    {
        key: "bello-lopez-miguel-angel",
        value: "bello-lopez-miguel-angel",
        text: "Bello López Miguel Ángel",
    },
    {
        key: "benavides-cuevas-david-felipe",
        value: "benavides-cuevas-david-felipe",
        text: "BENAVIDES CUEVAS DAVID FELIPE",
    },
    {
        key: "besio-giovanni",
        value: "besio-giovanni",
        text: "Besio Giovanni",
    },
    {
        key: "bocko-jozef",
        value: "bocko-jozef",
        text: "Bocko Jozef",
    },
    {
        key: "bravo-garcia-eva-maria",
        value: "bravo-garcia-eva-maria",
        text: "Bravo García, Eva María",
    },
    {
        key: "buitrago-esquinas-eva-maria",
        value: "buitrago-esquinas-eva-maria",
        text: "BUITRAGO ESQUINAS EVA MARIA",
    },
    {
        key: "calvo-de-mora-schmidt-arturo",
        value: "calvo-de-mora-schmidt-arturo",
        text: "Calvo de Mora Schmidt, Arturo",
    },
    {
        key: "camean-fernandez-ana-maria",
        value: "camean-fernandez-ana-maria",
        text: "CAMEAN FERNANDEZ ANA MARIA",
    },
    {
        key: "campos-mesa-maria-del-carmen",
        value: "campos-mesa-maria-del-carmen",
        text: "CAMPOS MESA MARIA DEL CARMEN",
    },
    {
        key: "candiani-simona",
        value: "candiani-simona",
        text: "Candiani Simona",
    },
    {
        key: "canovas-lopez-david",
        value: "canovas-lopez-david",
        text: "CANOVAS LOPEZ DAVID",
    },
    {
        key: "capitan-fernandez-jesus",
        value: "capitan-fernandez-jesus",
        text: "CAPITAN FERNANDEZ JESUS",
    },
    {
        key: "carlos-gutierrez-martin",
        value: "carlos-gutierrez-martin",
        text: "Carlos Gutiérrez-Martín",
    },
    {
        key: "carlos-leon-de-mora",
        value: "carlos-leon-de-mora",
        text: "Carlos León de Mora",
    },
    {
        key: "carlos-luque-moreno",
        value: "carlos-luque-moreno",
        text: "Carlos Luque Moreno",
    },
    {
        key: "carlos-marcelo-garcia",
        value: "carlos-marcelo-garcia",
        text: "Carlos Marcelo García",
    },
    {
        key: "carmen-andreu-lara",
        value: "carmen-andreu-lara",
        text: "Carmen Andreu Lara",
    },
    {
        key: "carmen-barroso-castro",
        value: "carmen-barroso-castro",
        text: "Carmen Barroso Castro",
    },
    {
        key: "carmen-galan-marin",
        value: "carmen-galan-marin",
        text: "Carmen Galán Marín",
    },
    {
        key: "carmen-llatas",
        value: "carmen-llatas",
        text: "CARMEN LLATAS",
    },
    {
        key: "carmen-moreno",
        value: "carmen-moreno",
        text: "Carmen Moreno",
    },
    {
        key: "carmen-ortiz-mellet",
        value: "carmen-ortiz-mellet",
        text: "Carmen Ortiz Mellet",
    },
    {
        key: "carrasco-paez",
        value: "carrasco-paez",
        text: "Carrasco Páez",
    },
    {
        key: "casa-rivas-luis-gonzalo-de-la",
        value: "casa-rivas-luis-gonzalo-de-la",
        text: "CASA RIVAS LUIS GONZALO DE LA",
    },
    {
        key: "cepeda-carrion-gabriel-alfonso",
        value: "cepeda-carrion-gabriel-alfonso",
        text: "CEPEDA CARRION GABRIEL ALFONSO",
    },
    {
        key: "chacartegui-ramirez-ricardo",
        value: "chacartegui-ramirez-ricardo",
        text: "CHACARTEGUI RAMIREZ RICARDO",
    },
    {
        key: "chacon-rebollo-tomas",
        value: "chacon-rebollo-tomas",
        text: "CHACON REBOLLO TOMAS",
    },
    {
        key: "charles-bouveyron",
        value: "charles-bouveyron",
        text: "Charles Bouveyron",
    },
    {
        key: "christine-mauz-korholz",
        value: "christine-mauz-korholz",
        text: "Christine Mauz-Körholz",
    },
    {
        key: "concepcion-foronda-robles",
        value: "concepcion-foronda-robles",
        text: "Concepción Foronda Robles",
    },
    {
        key: "corcoles-alicia",
        value: "corcoles-alicia",
        text: "CÓRCOLES Alicia",
    },
    {
        key: "cortes-giraldo-miguel-antonio",
        value: "cortes-giraldo-miguel-antonio",
        text: "CORTES GIRALDO MIGUEL ANTONIO",
    },
    {
        key: "cortes-sanchez-miguel",
        value: "cortes-sanchez-miguel",
        text: "CORTES SANCHEZ Miguel",
    },
    {
        key: "cristina-arevalo",
        value: "cristina-arevalo",
        text: "Cristina Arevalo",
    },
    {
        key: "cristina-torrecillas-lozano",
        value: "cristina-torrecillas-lozano",
        text: "CRistina Torrecillas Lozano",
    },
    {
        key: "cristobal-casanueva-rocha",
        value: "cristobal-casanueva-rocha",
        text: "Cristóbal Casanueva Rocha",
    },
    {
        key: "cruz-hernandez-norge",
        value: "cruz-hernandez-norge",
        text: "CRUZ HERNANDEZ NORGE",
    },
    {
        key: "damian-rivas",
        value: "damian-rivas",
        text: "Damián Rivas",
    },
    {
        key: "dan-sillett",
        value: "dan-sillett",
        text: "Dan Sillett",
    },
    {
        key: "daniel-gutierrez-reina",
        value: "daniel-gutierrez-reina",
        text: "Daniel Gutierrez Reina",
    },
    {
        key: "daniel-limon",
        value: "daniel-limon",
        text: "Daniel Limon",
    },
    {
        key: "daniela-marasova",
        value: "daniela-marasova",
        text: "Daniela Marasová",
    },
    {
        key: "david-saldana",
        value: "david-saldana",
        text: "David Saldaña",
    },
    {
        key: "de-la-cruz",
        value: "de-la-cruz",
        text: "de la cruz",
    },
    {
        key: "diaz-moreno-alberto",
        value: "diaz-moreno-alberto",
        text: "DÍAZ MORENO, ALBERTO",
    },
    {
        key: "dominguez-adame-lanuza-eduardo",
        value: "dominguez-adame-lanuza-eduardo",
        text: "DOMINGUEZ-ADAME LANUZA EDUARDO",
    },
    {
        key: "dra-gema-gonzalez-romero",
        value: "dra-gema-gonzalez-romero",
        text: "Dra. Gema Gonzalez-Romero",
    },
    {
        key: "drotar-peter",
        value: "drotar-peter",
        text: "Drotár Peter",
    },
    {
        key: "dusan-simsik",
        value: "dusan-simsik",
        text: "Dusan Simsik",
    },
    {
        key: "elisabetta-arato",
        value: "elisabetta-arato",
        text: "elisabetta arato",
    },
    {
        key: "emilia-ruiz-yamuza",
        value: "emilia-ruiz-yamuza",
        text: "Emilia Ruiz Yamuza",
    },
    {
        key: "enrique-fernandez-cara",
        value: "enrique-fernandez-cara",
        text: "Enrique Fernández Cara",
    },
    {
        key: "eric-rottinger",
        value: "eric-rottinger",
        text: "Eric Röttinger",
    },
    {
        key: "ernesto-chicardi",
        value: "ernesto-chicardi",
        text: "Ernesto Chicardi",
    },
    {
        key: "escalona-cuaresma-maria-jose",
        value: "escalona-cuaresma-maria-jose",
        text: "ESCALONA CUARESMA MARIA JOSE",
    },
    {
        key: "escano-gonzalez-jose-carlos",
        value: "escano-gonzalez-jose-carlos",
        text: "ESCAÑO GONZALEZ JOSE CARLOS",
    },
    {
        key: "esperanza-r-matarredona",
        value: "esperanza-r-matarredona",
        text: "Esperanza R Matarredona",
    },
    {
        key: "espigado-tocino-ildefonso",
        value: "espigado-tocino-ildefonso",
        text: "ESPIGADO TOCINO ILDEFONSO",
    },
    {
        key: "esteban-de-manuel-jerez",
        value: "esteban-de-manuel-jerez",
        text: "Esteban de Manuel Jerez",
    },
    {
        key: "fatima-roldan-castro",
        value: "fatima-roldan-castro",
        text: "Fátima Roldán Castro",
    },
    {
        key: "federico-paris",
        value: "federico-paris",
        text: "Federico París",
    },
    {
        key: "fedorko-gabriel",
        value: "fedorko-gabriel",
        text: "Fedorko Gabriel",
    },
    {
        key: "felipe-rosa",
        value: "felipe-rosa",
        text: "Felipe Rosa",
    },
    {
        key: "fernandez-chaves-manuel-francisco",
        value: "fernandez-chaves-manuel-francisco",
        text: "FERNANDEZ CHAVES MANUEL FRANCISCO",
    },
    {
        key: "fernando-bolivaar",
        value: "fernando-bolivaar",
        text: "Fernando Bolivaar",
    },
    {
        key: "fernando-guzman",
        value: "fernando-guzman",
        text: "Fernando Guzmán",
    },
    {
        key: "fernando-soler",
        value: "fernando-soler",
        text: "Fernando Soler",
    },
    {
        key: "fernando-vidal-barrero",
        value: "fernando-vidal-barrero",
        text: "Fernando Vidal Barrero",
    },
    {
        key: "ferreira-miguel-godinho",
        value: "ferreira-miguel-godinho",
        text: "Ferreira Miguel-Godinho",
    },
    {
        key: "flavio-gatti",
        value: "flavio-gatti",
        text: "flavio gatti",
    },
    {
        key: "framinan-torres-jose-manuel",
        value: "framinan-torres-jose-manuel",
        text: "FRAMIÑAN TORRES JOSE MANUEL",
    },
    {
        key: "francisco-j-heredia",
        value: "francisco-j-heredia",
        text: "Francisco J. Heredia",
    },
    {
        key: "francisco-javier-cano-garcia",
        value: "francisco-javier-cano-garcia",
        text: "FRANCISCO JAVIER CANO GARCIA",
    },
    {
        key: "francisco-medina-mena",
        value: "francisco-medina-mena",
        text: "Francisco Medina Mena",
    },
    {
        key: "francois-hug",
        value: "francois-hug",
        text: "François Hug",
    },
    {
        key: "frankovsky-peter",
        value: "frankovsky-peter",
        text: "Frankovský Peter",
    },
    {
        key: "frischhut-markus",
        value: "frischhut-markus",
        text: "Frischhut Markus",
    },
    {
        key: "fuentes-rodriguez-catalina",
        value: "fuentes-rodriguez-catalina",
        text: "FUENTES RODRIGUEZ CATALINA",
    },
    {
        key: "fuentes-rodriguez-catalina",
        value: "fuentes-rodriguez-catalina",
        text: "Fuentes Rodríguez, Catalina",
    },
    {
        key: "galan-marin-carmen",
        value: "galan-marin-carmen",
        text: "Galán-Marín Carmen",
    },
    {
        key: "gamiz-gordo-antonio",
        value: "gamiz-gordo-antonio",
        text: "GAMIZ GORDO ANTONIO",
    },
    {
        key: "garcia-benitez-francisco",
        value: "garcia-benitez-francisco",
        text: "GARCIA BENITEZ FRANCISCO",
    },
    {
        key: "garcia-de-casasola-gomez-marta",
        value: "garcia-de-casasola-gomez-marta",
        text: "GARCIA DE CASASOLA GOMEZ MARTA",
    },
    {
        key: "garcia-martin-juan-francisco",
        value: "garcia-martin-juan-francisco",
        text: "GARCIA MARTIN JUAN FRANCISCO",
    },
    {
        key: "garcia-quintanilla-alberto",
        value: "garcia-quintanilla-alberto",
        text: "GARCIA QUINTANILLA ALBERTO",
    },
    {
        key: "garcia-fernandez-jeronimo",
        value: "garcia-fernandez-jeronimo",
        text: "García-Fernández Jerónimo",
    },
    {
        key: "garcia-gordillo-maria-del-mar",
        value: "garcia-gordillo-maria-del-mar",
        text: "García-Gordillo, María del Mar",
    },
    {
        key: "gijon-nogueron",
        value: "gijon-nogueron",
        text: "Gijón-Noguerón",
    },
    {
        key: "giner-lamia-joaquin",
        value: "giner-lamia-joaquin",
        text: "GINER LAMIA JOAQUIN",
    },
    {
        key: "giordani-paolo",
        value: "giordani-paolo",
        text: "Giordani Paolo",
    },
    {
        key: "glova-jozef",
        value: "glova-jozef",
        text: "Glova Jozef",
    },
    {
        key: "golden-age-poetry-group-paso",
        value: "golden-age-poetry-group-paso",
        text: "Golden Age Poetry Group (PASO)",
    },
    {
        key: "gomez-piriz-pedro-tomas",
        value: "gomez-piriz-pedro-tomas",
        text: "GOMEZ PIRIZ PEDRO TOMAS",
    },
    {
        key: "gonzalez-diaz-maria-del-rocio",
        value: "gonzalez-diaz-maria-del-rocio",
        text: "GONZALEZ DIAZ MARIA DEL ROCIO",
    },
    {
        key: "gonzalez-lopez-jose-rafael",
        value: "gonzalez-lopez-jose-rafael",
        text: "GONZALEZ LOPEZ JOSE RAFAEL",
    },
    {
        key: "gonzalez-ramirez-juan-manuel",
        value: "gonzalez-ramirez-juan-manuel",
        text: "GONZALEZ RAMIREZ JUAN MANUEL",
    },
    {
        key: "gonzalez-rodriguez-maria-rosario",
        value: "gonzalez-rodriguez-maria-rosario",
        text: "GONZÁLEZ RODRIGUEZ MARIA ROSARIO",
    },
    {
        key: "guzman-simon-fernando",
        value: "guzman-simon-fernando",
        text: "GUZMAN SIMON Fernando",
    },
    {
        key: "hagarova-maria",
        value: "hagarova-maria",
        text: "Hagarová Mária",
    },
    {
        key: "halama-maros",
        value: "halama-maros",
        text: "Halama Maroš",
    },
    {
        key: "hernandez-de-santaolalla-aguilar-victor",
        value: "hernandez-de-santaolalla-aguilar-victor",
        text: "HERNANDEZ DE SANTAOLALLA AGUILAR VICTOR",
    },
    {
        key: "herrera-rafael",
        value: "herrera-rafael",
        text: "herrera Rafael",
    },
    {
        key: "hudak-radovan",
        value: "hudak-radovan",
        text: "Hudák Radovan",
    },
    {
        key: "ignacio-javier-acosta-garcia",
        value: "ignacio-javier-acosta-garcia",
        text: "Ignacio Javier Acosta García",
    },
    {
        key: "infante-rejano-eduardo",
        value: "infante-rejano-eduardo",
        text: "INFANTE REJANO Eduardo",
    },
    {
        key: "inmaculada-fernandez-fernandez",
        value: "inmaculada-fernandez-fernandez",
        text: "Inmaculada Fernández Fernández",
    },
    {
        key: "inmaculada-postigo",
        value: "inmaculada-postigo",
        text: "Inmaculada Postigo",
    },
    {
        key: "inmaculada-vivas-teson",
        value: "inmaculada-vivas-teson",
        text: "Inmaculada Vivas Tesón",
    },
    {
        key: "isabel-gonzalez",
        value: "isabel-gonzalez",
        text: "Isabel González",
    },
    {
        key: "isabel-herrera",
        value: "isabel-herrera",
        text: "Isabel Herrera",
    },
    {
        key: "isabel-maria-moreno-navarro",
        value: "isabel-maria-moreno-navarro",
        text: "Isabel María Moreno Navarro",
    },
    {
        key: "isabel-montes-romero-camacho",
        value: "isabel-montes-romero-camacho",
        text: "Isabel Montes Romero-Camacho",
    },
    {
        key: "isidoro-caraballo",
        value: "isidoro-caraballo",
        text: "Isidoro Caraballo",
    },
    {
        key: "japon-pineda-maria-de-los-angeles",
        value: "japon-pineda-maria-de-los-angeles",
        text: "JAPON PINEDA MARIA DE LOS ANGELES",
    },
    {
        key: "jaroslav-poruban",
        value: "jaroslav-poruban",
        text: "Jaroslav Porubän",
    },
    {
        key: "jaroslava-kadarova",
        value: "jaroslava-kadarova",
        text: "Jaroslava Kádárová",
    },
    {
        key: "javier-vitorica",
        value: "javier-vitorica",
        text: "Javier Vitorica",
    },
    {
        key: "jean-loic-cavazza",
        value: "jean-loic-cavazza",
        text: "Jean-Loïc CAVAZZA",
    },
    {
        key: "jesus-de-garay",
        value: "jesus-de-garay",
        text: "Jesús de Garay",
    },
    {
        key: "jesus-de-la-cruz-diaz",
        value: "jesus-de-la-cruz-diaz",
        text: "Jesús de la Cruz Díaz",
    },
    {
        key: "jesus-fernandez-gavira",
        value: "jesus-fernandez-gavira",
        text: "Jesús Fernández Gavira",
    },
    {
        key: "jimenez-losada-andres",
        value: "jimenez-losada-andres",
        text: "JIMENEZ LOSADA ANDRES",
    },
    {
        key: "jorge-juan-chico",
        value: "jorge-juan-chico",
        text: "Jorge Juan Chico",
    },
    {
        key: "jose-agustin-vidal-dominguez",
        value: "jose-agustin-vidal-dominguez",
        text: "José Agustín Vidal Domínguez",
    },
    {
        key: "jose-antonio-aguilar-galea",
        value: "jose-antonio-aguilar-galea",
        text: "José Antonio Aguilar Galea",
    },
    {
        key: "jose-antonio-reinoso-cuevas",
        value: "jose-antonio-reinoso-cuevas",
        text: "Jose Antonio Reinoso Cuevas",
    },
    {
        key: "jose-cotrino",
        value: "jose-cotrino",
        text: "José Cotrino",
    },
    {
        key: "jose-cristobal-riquelme-santos",
        value: "jose-cristobal-riquelme-santos",
        text: "José Cristóbal Riquelme Santos",
    },
    {
        key: "jose-fernandez-serrano",
        value: "jose-fernandez-serrano",
        text: "JOSE FERNANDEZ SERRANO",
    },
    {
        key: "jose-ferreiros",
        value: "jose-ferreiros",
        text: "José Ferreirós",
    },
    {
        key: "jose-leon-carrion",
        value: "jose-leon-carrion",
        text: "JOSE LEON-CARRION",
    },
    {
        key: "jose-luis-pino-mejias",
        value: "jose-luis-pino-mejias",
        text: "José Luis Pino Mejías",
    },
    {
        key: "jose-luis-venero",
        value: "jose-luis-venero",
        text: "José Luis Venero",
    },
    {
        key: "jose-luis-venero",
        value: "jose-luis-venero",
        text: "Jose Luis Venero",
    },
    {
        key: "jose-manuel-quintero-ariza",
        value: "jose-manuel-quintero-ariza",
        text: "Jose Manuel Quintero Ariza",
    },
    {
        key: "jose-maria-cabeza-lainez",
        value: "jose-maria-cabeza-lainez",
        text: "José María Cabeza Laínez",
    },
    {
        key: "jose-ojeda",
        value: "jose-ojeda",
        text: "José Ojeda",
    },
    {
        key: "jose-ordonez-garcia",
        value: "jose-ordonez-garcia",
        text: "José Ordóñez-García",
    },
    {
        key: "jovancevic-igor",
        value: "jovancevic-igor",
        text: "Jovancevic Igor",
    },
    {
        key: "juan-a-martinez-roman",
        value: "juan-a-martinez-roman",
        text: "Juan A. Martinez Roman",
    },
    {
        key: "juan-carlos-bravo-rodriguez",
        value: "juan-carlos-bravo-rodriguez",
        text: "Juan Carlos Bravo Rodríguez",
    },
    {
        key: "juan-carlos-bravo-rodriguez",
        value: "juan-carlos-bravo-rodriguez",
        text: "Juan Carlos Bravo-Rodríguez",
    },
    {
        key: "juan-chico-jorge",
        value: "juan-chico-jorge",
        text: "JUAN CHICO JORGE",
    },
    {
        key: "juan-jose-sendra-salas",
        value: "juan-jose-sendra-salas",
        text: "Juan José Sendra Salas",
    },
    {
        key: "juan-montero",
        value: "juan-montero",
        text: "juan montero",
    },
    {
        key: "juan-polo",
        value: "juan-polo",
        text: "Juan Polo",
    },
    {
        key: "juraj-sebo",
        value: "juraj-sebo",
        text: "Juraj Šebo",
    },
    {
        key: "kormanikova-eva",
        value: "kormanikova-eva",
        text: "KORMANÍKOVÁ Eva",
    },
    {
        key: "krenicky-tibor",
        value: "krenicky-tibor",
        text: "Krenický Tibor",
    },
    {
        key: "labio-bernal-aurora-maria",
        value: "labio-bernal-aurora-maria",
        text: "LABIO BERNAL AURORA MARIA",
    },
    {
        key: "laura-maija-hero",
        value: "laura-maija-hero",
        text: "Laura-Maija Hero",
    },
    {
        key: "lebrato-martinez-julian",
        value: "lebrato-martinez-julian",
        text: "LEBRATO MARTINEZ JULIAN",
    },
    {
        key: "lenero-bardallo-juan-antonio",
        value: "lenero-bardallo-juan-antonio",
        text: "LEÑERO BARDALLO JUAN ANTONIO",
    },
    {
        key: "leon-perez-jose-maria",
        value: "leon-perez-jose-maria",
        text: "LEON PEREZ JOSE MARIA",
    },
    {
        key: "leonardo-garcia-sanjuan",
        value: "leonardo-garcia-sanjuan",
        text: "Leonardo García-Sanjuán",
    },
    {
        key: "leonardo-ruiz-sanchez",
        value: "leonardo-ruiz-sanchez",
        text: "Leonardo Ruiz Sánchez",
    },
    {
        key: "lilic-milica",
        value: "lilic-milica",
        text: "Lilic Milica",
    },
    {
        key: "limon-belen-maria",
        value: "limon-belen-maria",
        text: "LIMON BELEN MARIA",
    },
    {
        key: "lopez-maury-luis",
        value: "lopez-maury-luis",
        text: "LOPEZ MAURY LUIS",
    },
    {
        key: "lopez-redondo-isaac",
        value: "lopez-redondo-isaac",
        text: "Lopez Redondo, Isaac",
    },
    {
        key: "luis-a-palma-martos",
        value: "luis-a-palma-martos",
        text: "Luis A. Palma Martos",
    },
    {
        key: "luis-francisco-martinez-montiel",
        value: "luis-francisco-martinez-montiel",
        text: "Luis Francisco Martínez Montiel",
    },
    {
        key: "luis-javier-reina-tosina",
        value: "luis-javier-reina-tosina",
        text: "Luis Javier Reina Tosina",
    },
    {
        key: "m-carmen-campos-mesa",
        value: "m-carmen-campos-mesa",
        text: "M. Carmen Campos Mesa",
    },
    {
        key: "machova-kristina",
        value: "machova-kristina",
        text: "Machová Kristína",
    },
    {
        key: "madelyn-marrero",
        value: "madelyn-marrero",
        text: "Madelyn Marrero",
    },
    {
        key: "mancera-martinez-manuel-fernando",
        value: "mancera-martinez-manuel-fernando",
        text: "MANCERA MARTINEZ MANUEL FERNANDO",
    },
    {
        key: "manuel-garcia-leon",
        value: "manuel-garcia-leon",
        text: "manuel garcía-león",
    },
    {
        key: "marchena-fernandez-juan",
        value: "marchena-fernandez-juan",
        text: "Marchena Fernández, Juan",
    },
    {
        key: "margarida-romero",
        value: "margarida-romero",
        text: "margarida Romero",
    },
    {
        key: "mari-carmen-millan-linares",
        value: "mari-carmen-millan-linares",
        text: "Mari Carmen Millán LInares",
    },
    {
        key: "maria-belen-molina-huete",
        value: "maria-belen-molina-huete",
        text: "María Belén Molina Huete",
    },
    {
        key: "maria-camino-gutierrez-lanza",
        value: "maria-camino-gutierrez-lanza",
        text: "María Camino Gutiérrez Lanza",
    },
    {
        key: "maria-del-carmen-garcia-parrilla",
        value: "maria-del-carmen-garcia-parrilla",
        text: "Maria del Carmen Garcia Parrilla",
    },
    {
        key: "maria-del-carmen-serrano-gotarredona",
        value: "maria-del-carmen-serrano-gotarredona",
        text: "María del Carmen Serrano Gotarredona",
    },
    {
        key: "maria-f-carrascal",
        value: "maria-f-carrascal",
        text: "María F. Carrascal",
    },
    {
        key: "maria-jesus-cala-carrillo",
        value: "maria-jesus-cala-carrillo",
        text: "maria jesus cala carrillo",
    },
    {
        key: "maria-jose-avedillo-de-juan",
        value: "maria-jose-avedillo-de-juan",
        text: "Maria José Avedillo de Juan",
    },
    {
        key: "maria-jose-escalona-cuaresma",
        value: "maria-jose-escalona-cuaresma",
        text: "Maria José Escalona Cuaresma",
    },
    {
        key: "maria-teresa-gomez-lopez",
        value: "maria-teresa-gomez-lopez",
        text: "María Teresa Gómez López",
    },
    {
        key: "mario-ivan-zignego",
        value: "mario-ivan-zignego",
        text: "Mario Ivan Zignego",
    },
    {
        key: "marisa-vadillo",
        value: "marisa-vadillo",
        text: "Marisa Vadillo",
    },
    {
        key: "marquez-alberto",
        value: "marquez-alberto",
        text: "Marquez Alberto",
    },
    {
        key: "marrero-melendez-madelyn-rosa",
        value: "marrero-melendez-madelyn-rosa",
        text: "MARRERO MELENDEZ MADELYN ROSA",
    },
    {
        key: "martin-baca",
        value: "martin-baca",
        text: "Martin Bača",
    },
    {
        key: "martin-sisol",
        value: "martin-sisol",
        text: "Martin Sisol",
    },
    {
        key: "martinez-de-pablos-rocio",
        value: "martinez-de-pablos-rocio",
        text: "Martínez de Pablos Rocío",
    },
    {
        key: "martinez-torres-maria-del-rocio",
        value: "martinez-torres-maria-del-rocio",
        text: "MARTINEZ TORRES MARIA DEL ROCIO",
    },
    {
        key: "mate-barrero-alfonso",
        value: "mate-barrero-alfonso",
        text: "MATE BARRERO ALFONSO",
    },
    {
        key: "matus-pleva",
        value: "matus-pleva",
        text: "Matus Pleva",
    },
    {
        key: "maya-jariego-isidro",
        value: "maya-jariego-isidro",
        text: "MAYA JARIEGO ISIDRO",
    },
    {
        key: "mercedes-oria-segura",
        value: "mercedes-oria-segura",
        text: "Mercedes Oria Segura",
    },
    {
        key: "metodologia-estadistica-y-psicometria-aplicada-a-las-ciencias-del-comportamiento-y-de-la-salud",
        value: "metodologia-estadistica-y-psicometria-aplicada-a-las-ciencias-del-comportamiento-y-de-la-salud",
        text: "Metodología, Estadística y Psicometría Aplicada a las Ciencias del Comportamiento y de la Salud",
    },
    {
        key: "michal-cehlar",
        value: "michal-cehlar",
        text: "Michal Cehlar",
    },
    {
        key: "miguel-c-moya-morales",
        value: "miguel-c-moya-morales",
        text: "Miguel C. Moya Morales",
    },
    {
        key: "miroslav-badida",
        value: "miroslav-badida",
        text: "Miroslav Badida",
    },
    {
        key: "moises-grimaldi-puyana",
        value: "moises-grimaldi-puyana",
        text: "Moisés Grimaldi Puyana",
    },
    {
        key: "molinari-chiara",
        value: "molinari-chiara",
        text: "Molinari Chiara",
    },
    {
        key: "monreal-jose-antonio",
        value: "monreal-jose-antonio",
        text: "Monreal Jose Antonio",
    },
    {
        key: "moreno-navarro-isabel-maria",
        value: "moreno-navarro-isabel-maria",
        text: "MORENO NAVARRO ISABEL MARIA",
    },
    {
        key: "mosenhauer-moritz",
        value: "mosenhauer-moritz",
        text: "Mosenhauer Moritz",
    },
    {
        key: "motrico-martinez-emma",
        value: "motrico-martinez-emma",
        text: "MOTRICO MARTINEZ EMMA",
    },
    {
        key: "muntane-relat-jordi",
        value: "muntane-relat-jordi",
        text: "MUNTANE RELAT JORDI",
    },
    {
        key: "muro-jimenez-fernando",
        value: "muro-jimenez-fernando",
        text: "MURO JIMENEZ FERNANDO",
    },
    {
        key: "nervi-mario",
        value: "nervi-mario",
        text: "Nervi Mario",
    },
    {
        key: "nunez-roman-francisco",
        value: "nunez-roman-francisco",
        text: "NUÑEZ ROMAN FRANCISCO",
    },
    {
        key: "ortega-ramirez-juan-antonio",
        value: "ortega-ramirez-juan-antonio",
        text: "ORTEGA RAMIREZ JUAN ANTONIO",
    },
    {
        key: "pablo-mir-rivera",
        value: "pablo-mir-rivera",
        text: "Pablo Mir Rivera",
    },
    {
        key: "padilla-cruz-manuel",
        value: "padilla-cruz-manuel",
        text: "PADILLA CRUZ MANUEL",
    },
    {
        key: "paralic-jan",
        value: "paralic-jan",
        text: "Paralic Jan",
    },
    {
        key: "pascal-staccini",
        value: "pascal-staccini",
        text: "PASCAL STACCINI",
    },
    {
        key: "pascal-staccini",
        value: "pascal-staccini",
        text: "pascal Staccini",
    },
    {
        key: "paula-gonzalez-rodriguez",
        value: "paula-gonzalez-rodriguez",
        text: "PAULA GONZALEZ RODRIGUEZ",
    },
    {
        key: "pedro-ramiro-palos-sanchez",
        value: "pedro-ramiro-palos-sanchez",
        text: "Pedro Ramiro Palos Sánchez",
    },
    {
        key: "perez-cano-maria-teresa",
        value: "perez-cano-maria-teresa",
        text: "PEREZ CANO MARIA TERESA",
    },
    {
        key: "perez-urrestarazu-luis",
        value: "perez-urrestarazu-luis",
        text: "PEREZ URRESTARAZU LUIS",
    },
    {
        key: "peter-dzupka",
        value: "peter-dzupka",
        text: "Peter Džupka",
    },
    {
        key: "piedra-de-la-cuadra-joaquin",
        value: "piedra-de-la-cuadra-joaquin",
        text: "PIEDRA DE LA CUADRA JOAQUIN",
    },
    {
        key: "pinuaga-linares-eduardo",
        value: "pinuaga-linares-eduardo",
        text: "Pinuaga Linares Eduardo",
    },
    {
        key: "pitel-jan",
        value: "pitel-jan",
        text: "Piteľ Ján",
    },
    {
        key: "prado-velasco-manuel",
        value: "prado-velasco-manuel",
        text: "PRADO VELASCO MANUEL",
    },
    {
        key: "rafael-herrera",
        value: "rafael-herrera",
        text: "Rafael Herrera",
    },
    {
        key: "rafael-herrera-limones",
        value: "rafael-herrera-limones",
        text: "Rafael Herrera Limones",
    },
    {
        key: "raffaele-bolla",
        value: "raffaele-bolla",
        text: "Raffaele Bolla",
    },
    {
        key: "ramirez-rico-joaquin",
        value: "ramirez-rico-joaquin",
        text: "RAMIREZ RICO JOAQUIN",
    },
    {
        key: "real-jurado-pedro",
        value: "real-jurado-pedro",
        text: "REAL JURADO PEDRO",
    },
    {
        key: "reguera-alvarado-nuria",
        value: "reguera-alvarado-nuria",
        text: "REGUERA ALVARADO NURIA",
    },
    {
        key: "resinas-arias-de-reyna-manuel",
        value: "resinas-arias-de-reyna-manuel",
        text: "RESINAS ARIAS DE REYNA MANUEL",
    },
    {
        key: "respaldiza-galisteo-miguel-angel",
        value: "respaldiza-galisteo-miguel-angel",
        text: "RESPALDIZA GALISTEO MIGUEL ANGEL",
    },
    {
        key: "ries-francis",
        value: "ries-francis",
        text: "RIES FRANCIS",
    },
    {
        key: "robert-rozenberg",
        value: "robert-rozenberg",
        text: "Robert ROZENBERG",
    },
    {
        key: "roberto-galan",
        value: "roberto-galan",
        text: "Roberto Galán",
    },
    {
        key: "rocio-valderrama-hernandez",
        value: "rocio-valderrama-hernandez",
        text: "Rocío Valderrama Hernández",
    },
    {
        key: "rodriguez-cunill-maria-inmaculada",
        value: "rodriguez-cunill-maria-inmaculada",
        text: "RODRIGUEZ CUNILL MARIA INMACULADA",
    },
    {
        key: "rodriguez-testal-juan-francisco",
        value: "rodriguez-testal-juan-francisco",
        text: "RODRIGUEZ TESTAL JUAN FRANCISCO",
    },
    {
        key: "romero-perez-clara",
        value: "romero-perez-clara",
        text: "ROMERO PEREZ CLARA",
    },
    {
        key: "rosario-del-rey-alamillo",
        value: "rosario-del-rey-alamillo",
        text: "ROSARIO DEL REY ALAMILLO",
    },
    {
        key: "saksl-karel",
        value: "saksl-karel",
        text: "Saksl Karel",
    },
    {
        key: "saliga-jan",
        value: "saliga-jan",
        text: "Šaliga Ján",
    },
    {
        key: "salvador-chacon-moscoso",
        value: "salvador-chacon-moscoso",
        text: "Salvador Chacon Moscoso",
    },
    {
        key: "sanudo-corrales-francisco-de-borja",
        value: "sanudo-corrales-francisco-de-borja",
        text: "SAÑUDO CORRALES FRANCISCO DE BORJA",
    },
    {
        key: "schnitzer-marek",
        value: "schnitzer-marek",
        text: "Schnitzer Marek",
    },
    {
        key: "simkulet-vladimir",
        value: "simkulet-vladimir",
        text: "Simkulet Vladimír",
    },
    {
        key: "slota-jan",
        value: "slota-jan",
        text: "Slota Ján",
    },
    {
        key: "stefko-robert",
        value: "stefko-robert",
        text: "Štefko Róbert",
    },
    {
        key: "straka-martin",
        value: "straka-martin",
        text: "Straka Martin",
    },
    {
        key: "tarik-smani",
        value: "tarik-smani",
        text: "Tarik Smani",
    },
    {
        key: "tep196-electrical-power-systems",
        value: "tep196-electrical-power-systems",
        text: "TEP196: Electrical Power Systems",
    },
    {
        key: "torrecillas-lozano-cristina",
        value: "torrecillas-lozano-cristina",
        text: "TORRECILLAS LOZANO CRISTINA",
    },
    {
        key: "utrera-maria-victoria",
        value: "utrera-maria-victoria",
        text: "Utrera, María Victoria",
    },
    {
        key: "vanova-patricia",
        value: "vanova-patricia",
        text: "Vaňová Patrícia",
    },
    {
        key: "vargas-romero-juan-pedro",
        value: "vargas-romero-juan-pedro",
        text: "VARGAS ROMERO JUAN PEDRO",
    },
    {
        key: "vega-moreno-francisco-manuel",
        value: "vega-moreno-francisco-manuel",
        text: "VEGA MORENO Francisco Manuel",
    },
    {
        key: "velgosova-oksana",
        value: "velgosova-oksana",
        text: "Velgosová Oksana",
    },
    {
        key: "vidal-barrero-jose-fernando",
        value: "vidal-barrero-jose-fernando",
        text: "VIDAL BARRERO JOSE FERNANDO",
    },
    {
        key: "vilcekova-silvia",
        value: "vilcekova-silvia",
        text: "Vilčeková Silvia",
    },
    {
        key: "villalobo-polo-eduardo",
        value: "villalobo-polo-eduardo",
        text: "VILLALOBO POLO EDUARDO",
    },
    {
        key: "voliani-valerio",
        value: "voliani-valerio",
        text: "Voliani Valerio",
    },
    {
        key: "vranayova-zuzana",
        value: "vranayova-zuzana",
        text: "Vranayová Zuzana",
    },
    {
        key: "xx",
        value: "xx",
        text: "xx",
    },
    {
        key: "yniguez-ovando-rocio",
        value: "yniguez-ovando-rocio",
        text: "YÑIGUEZ OVANDO ROCIO",
    },
];

export const expertiseThematicOptions = [
    {
        key: "1135",
        value: "1135",
        text: "agricultural sciences",
    },
    {
        key: "1174",
        value: "1174",
        text: "engineering and technology",
    },
    {
        key: "1383",
        value: "1383",
        text: "humanities",
    },
    {
        key: "1450",
        value: "1450",
        text: "medical and health sciences",
    },
    {
        key: "1627",
        value: "1627",
        text: "natural sciences",
    },
    {
        key: "2019",
        value: "2019",
        text: "social sciences",
    },
];

export const expertiseKeywordsOptions = [
    {
        key: "4g",
        value: "4g",
        text: "4G",
    },
    {
        key: "5g",
        value: "5g",
        text: "5G",
    },
    {
        key: "dna",
        value: "dna",
        text: "DNA",
    },
    {
        key: "dna-viruses",
        value: "dna-viruses",
        text: "DNA viruses",
    },
    {
        key: "hiv",
        value: "hiv",
        text: "HIV",
    },
    {
        key: "l-functions",
        value: "l-functions",
        text: "L-functions",
    },
    {
        key: "lifi",
        value: "lifi",
        text: "LiFi",
    },
    {
        key: "rna",
        value: "rna",
        text: "RNA",
    },
    {
        key: "rna-viruses",
        value: "rna-viruses",
        text: "RNA viruses",
    },
    {
        key: "wifi",
        value: "wifi",
        text: "WiFi",
    },
    {
        key: "absorption-spectroscopy",
        value: "absorption-spectroscopy",
        text: "absorption spectroscopy",
    },
    {
        key: "access-control",
        value: "access-control",
        text: "access control",
    },
    {
        key: "acoustics",
        value: "acoustics",
        text: "acoustics",
    },
    {
        key: "active-learning",
        value: "active-learning",
        text: "active learning",
    },
    {
        key: "additive-manufacturing",
        value: "additive-manufacturing",
        text: "additive manufacturing",
    },
    {
        key: "admiralty-law",
        value: "admiralty-law",
        text: "admiralty law",
    },
    {
        key: "adverse-drug-reactions",
        value: "adverse-drug-reactions",
        text: "adverse drug reactions",
    },
    {
        key: "aeronautical-engineering",
        value: "aeronautical-engineering",
        text: "aeronautical engineering",
    },
    {
        key: "aerospace-engineering",
        value: "aerospace-engineering",
        text: "aerospace engineering",
    },
    {
        key: "age-inequality",
        value: "age-inequality",
        text: "age inequality",
    },
    {
        key: "agricultural-biotechnology",
        value: "agricultural-biotechnology",
        text: "agricultural biotechnology",
    },
    {
        key: "agricultural-genetics",
        value: "agricultural-genetics",
        text: "agricultural genetics",
    },
    {
        key: "agriculture",
        value: "agriculture",
        text: "agriculture",
    },
    {
        key: "agriculture,-forestry,-and-fisheries",
        value: "agriculture,-forestry,-and-fisheries",
        text: "agriculture, forestry, and fisheries",
    },
    {
        key: "agronomy",
        value: "agronomy",
        text: "agronomy",
    },
    {
        key: "air-pollution-engineering",
        value: "air-pollution-engineering",
        text: "air pollution engineering",
    },
    {
        key: "air-traffic-management",
        value: "air-traffic-management",
        text: "air traffic management",
    },
    {
        key: "aircraft",
        value: "aircraft",
        text: "aircraft",
    },
    {
        key: "airport-engineering",
        value: "airport-engineering",
        text: "airport engineering",
    },
    {
        key: "alcohols",
        value: "alcohols",
        text: "alcohols",
    },
    {
        key: "aldehydes",
        value: "aldehydes",
        text: "aldehydes",
    },
    {
        key: "algebra",
        value: "algebra",
        text: "algebra",
    },
    {
        key: "algebraic-geometry",
        value: "algebraic-geometry",
        text: "algebraic geometry",
    },
    {
        key: "algebraic-topology",
        value: "algebraic-topology",
        text: "algebraic topology",
    },
    {
        key: "aliphatic-compounds",
        value: "aliphatic-compounds",
        text: "aliphatic compounds",
    },
    {
        key: "alkali-metals",
        value: "alkali-metals",
        text: "alkali metals",
    },
    {
        key: "alkaline-earth-metals",
        value: "alkaline-earth-metals",
        text: "alkaline earth metals",
    },
    {
        key: "allergology",
        value: "allergology",
        text: "allergology",
    },
    {
        key: "alzheimer",
        value: "alzheimer",
        text: "alzheimer",
    },
    {
        key: "amines",
        value: "amines",
        text: "amines",
    },
    {
        key: "amyotrophic-lateral-sclerosis",
        value: "amyotrophic-lateral-sclerosis",
        text: "amyotrophic lateral sclerosis",
    },
    {
        key: "anaesthesiology",
        value: "anaesthesiology",
        text: "anaesthesiology",
    },
    {
        key: "analogue-electronics",
        value: "analogue-electronics",
        text: "analogue electronics",
    },
    {
        key: "analytical-chemistry",
        value: "analytical-chemistry",
        text: "analytical chemistry",
    },
    {
        key: "anatomy-and-morphology",
        value: "anatomy-and-morphology",
        text: "anatomy and morphology",
    },
    {
        key: "ancient-history",
        value: "ancient-history",
        text: "ancient history",
    },
    {
        key: "ancient-philosophy",
        value: "ancient-philosophy",
        text: "ancient philosophy",
    },
    {
        key: "andrology",
        value: "andrology",
        text: "andrology",
    },
    {
        key: "angiology",
        value: "angiology",
        text: "angiology",
    },
    {
        key: "animal-and-dairy-science",
        value: "animal-and-dairy-science",
        text: "animal and dairy science",
    },
    {
        key: "animal-feed",
        value: "animal-feed",
        text: "animal feed",
    },
    {
        key: "animal-husbandry",
        value: "animal-husbandry",
        text: "animal husbandry",
    },
    {
        key: "anthropology",
        value: "anthropology",
        text: "anthropology",
    },
    {
        key: "antibiotic-resistance",
        value: "antibiotic-resistance",
        text: "antibiotic resistance",
    },
    {
        key: "antibiotics",
        value: "antibiotics",
        text: "antibiotics",
    },
    {
        key: "antivirals",
        value: "antivirals",
        text: "antivirals",
    },
    {
        key: "anxiety-disorders",
        value: "anxiety-disorders",
        text: "anxiety disorders",
    },
    {
        key: "apiculture",
        value: "apiculture",
        text: "apiculture",
    },
    {
        key: "apidology",
        value: "apidology",
        text: "apidology",
    },
    {
        key: "applied-mathematics",
        value: "applied-mathematics",
        text: "applied mathematics",
    },
    {
        key: "applied-mechanics",
        value: "applied-mechanics",
        text: "applied mechanics",
    },
    {
        key: "arboriculture",
        value: "arboriculture",
        text: "arboriculture",
    },
    {
        key: "archaeology",
        value: "archaeology",
        text: "archaeology",
    },
    {
        key: "archaeometry",
        value: "archaeometry",
        text: "archaeometry",
    },
    {
        key: "architectural-design",
        value: "architectural-design",
        text: "architectural design",
    },
    {
        key: "architecture-engineering",
        value: "architecture-engineering",
        text: "architecture engineering",
    },
    {
        key: "arithmetics",
        value: "arithmetics",
        text: "arithmetics",
    },
    {
        key: "armed-conflicts",
        value: "armed-conflicts",
        text: "armed conflicts",
    },
    {
        key: "aromatic-compounds",
        value: "aromatic-compounds",
        text: "aromatic compounds",
    },
    {
        key: "art-history",
        value: "art-history",
        text: "art history",
    },
    {
        key: "arteriosclerosis",
        value: "arteriosclerosis",
        text: "arteriosclerosis",
    },
    {
        key: "artificial-bone",
        value: "artificial-bone",
        text: "artificial bone",
    },
    {
        key: "artificial-intelligence",
        value: "artificial-intelligence",
        text: "artificial intelligence",
    },
    {
        key: "artificial-pancreas",
        value: "artificial-pancreas",
        text: "artificial pancreas",
    },
    {
        key: "arts",
        value: "arts",
        text: "arts",
    },
    {
        key: "asteroids",
        value: "asteroids",
        text: "asteroids",
    },
    {
        key: "asteroseismology",
        value: "asteroseismology",
        text: "asteroseismology",
    },
    {
        key: "asthma",
        value: "asthma",
        text: "asthma",
    },
    {
        key: "astrochemistry",
        value: "astrochemistry",
        text: "astrochemistry",
    },
    {
        key: "astronautical-engineering",
        value: "astronautical-engineering",
        text: "astronautical engineering",
    },
    {
        key: "astronomy",
        value: "astronomy",
        text: "astronomy",
    },
    {
        key: "astrophysics",
        value: "astrophysics",
        text: "astrophysics",
    },
    {
        key: "atmospheric-circulation",
        value: "atmospheric-circulation",
        text: "atmospheric circulation",
    },
    {
        key: "atmospheric-pressure",
        value: "atmospheric-pressure",
        text: "atmospheric pressure",
    },
    {
        key: "atmospheric-sciences",
        value: "atmospheric-sciences",
        text: "atmospheric sciences",
    },
    {
        key: "atmospheric-turbulence",
        value: "atmospheric-turbulence",
        text: "atmospheric turbulence",
    },
    {
        key: "atomic-physics",
        value: "atomic-physics",
        text: "atomic physics",
    },
    {
        key: "autoimmune-diseases",
        value: "autoimmune-diseases",
        text: "autoimmune diseases",
    },
    {
        key: "automation",
        value: "automation",
        text: "automation",
    },
    {
        key: "automotive-engineering",
        value: "automotive-engineering",
        text: "automotive engineering",
    },
    {
        key: "autonomous-robots",
        value: "autonomous-robots",
        text: "autonomous robots",
    },
    {
        key: "autonomous-vehicles",
        value: "autonomous-vehicles",
        text: "autonomous vehicles",
    },
    {
        key: "bacteriology",
        value: "bacteriology",
        text: "bacteriology",
    },
    {
        key: "basal-cells",
        value: "basal-cells",
        text: "basal cells",
    },
    {
        key: "base-isolation",
        value: "base-isolation",
        text: "base isolation",
    },
    {
        key: "basic-medicine",
        value: "basic-medicine",
        text: "basic medicine",
    },
    {
        key: "bayesian-statistics",
        value: "bayesian-statistics",
        text: "bayesian statistics",
    },
    {
        key: "behavioural-ecology",
        value: "behavioural-ecology",
        text: "behavioural ecology",
    },
    {
        key: "behavioural-psychology",
        value: "behavioural-psychology",
        text: "behavioural psychology",
    },
    {
        key: "big-bang",
        value: "big-bang",
        text: "big bang",
    },
    {
        key: "big-data",
        value: "big-data",
        text: "big data",
    },
    {
        key: "bioarchaeology",
        value: "bioarchaeology",
        text: "bioarchaeology",
    },
    {
        key: "bioartificial-liver",
        value: "bioartificial-liver",
        text: "bioartificial liver",
    },
    {
        key: "biocatalysis",
        value: "biocatalysis",
        text: "biocatalysis",
    },
    {
        key: "biochemical-engineering",
        value: "biochemical-engineering",
        text: "biochemical engineering",
    },
    {
        key: "biochemistry",
        value: "biochemistry",
        text: "biochemistry",
    },
    {
        key: "biocomposites",
        value: "biocomposites",
        text: "biocomposites",
    },
    {
        key: "biodiversity-conservation",
        value: "biodiversity-conservation",
        text: "biodiversity conservation",
    },
    {
        key: "bioeconomy",
        value: "bioeconomy",
        text: "bioeconomy",
    },
    {
        key: "bioelectrochemistry",
        value: "bioelectrochemistry",
        text: "bioelectrochemistry",
    },
    {
        key: "biofuels",
        value: "biofuels",
        text: "biofuels",
    },
    {
        key: "biogeochemistry",
        value: "biogeochemistry",
        text: "biogeochemistry",
    },
    {
        key: "bioinorganic-chemistry",
        value: "bioinorganic-chemistry",
        text: "bioinorganic chemistry",
    },
    {
        key: "bioleaching",
        value: "bioleaching",
        text: "bioleaching",
    },
    {
        key: "biological-behavioural-sciences",
        value: "biological-behavioural-sciences",
        text: "biological behavioural sciences",
    },
    {
        key: "biological-interactions",
        value: "biological-interactions",
        text: "biological interactions",
    },
    {
        key: "biological-morphology",
        value: "biological-morphology",
        text: "biological morphology",
    },
    {
        key: "biological-sciences",
        value: "biological-sciences",
        text: "biological sciences",
    },
    {
        key: "biomass",
        value: "biomass",
        text: "biomass",
    },
    {
        key: "biomaterials",
        value: "biomaterials",
        text: "biomaterials",
    },
    {
        key: "biomolecules",
        value: "biomolecules",
        text: "biomolecules",
    },
    {
        key: "biophysics",
        value: "biophysics",
        text: "biophysics",
    },
    {
        key: "bioplastics",
        value: "bioplastics",
        text: "bioplastics",
    },
    {
        key: "bioprocessing-technologies",
        value: "bioprocessing-technologies",
        text: "bioprocessing technologies",
    },
    {
        key: "bioreactors",
        value: "bioreactors",
        text: "bioreactors",
    },
    {
        key: "bioremediation",
        value: "bioremediation",
        text: "bioremediation",
    },
    {
        key: "biosensing",
        value: "biosensing",
        text: "biosensing",
    },
    {
        key: "biosensors",
        value: "biosensors",
        text: "biosensors",
    },
    {
        key: "biosphera",
        value: "biosphera",
        text: "biosphera",
    },
    {
        key: "biostratigraphy",
        value: "biostratigraphy",
        text: "biostratigraphy",
    },
    {
        key: "black-holes",
        value: "black-holes",
        text: "black holes",
    },
    {
        key: "bladder-cancer",
        value: "bladder-cancer",
        text: "bladder cancer",
    },
    {
        key: "bluetooth",
        value: "bluetooth",
        text: "bluetooth",
    },
    {
        key: "bose-einstein-condensates",
        value: "bose-einstein-condensates",
        text: "bose-einstein condensates",
    },
    {
        key: "botany",
        value: "botany",
        text: "botany",
    },
    {
        key: "breast-cancer",
        value: "breast-cancer",
        text: "breast cancer",
    },
    {
        key: "breast-implants",
        value: "breast-implants",
        text: "breast implants",
    },
    {
        key: "bulk-nanostructured-materials",
        value: "bulk-nanostructured-materials",
        text: "bulk nanostructured materials",
    },
    {
        key: "bureaucracy",
        value: "bureaucracy",
        text: "bureaucracy",
    },
    {
        key: "business-and-management",
        value: "business-and-management",
        text: "business and management",
    },
    {
        key: "business-intelligence",
        value: "business-intelligence",
        text: "business intelligence",
    },
    {
        key: "business-models",
        value: "business-models",
        text: "business models",
    },
    {
        key: "calorimetry",
        value: "calorimetry",
        text: "calorimetry",
    },
    {
        key: "carbohydrates",
        value: "carbohydrates",
        text: "carbohydrates",
    },
    {
        key: "carbon-capture-engineering",
        value: "carbon-capture-engineering",
        text: "carbon capture engineering",
    },
    {
        key: "carbon-fibers",
        value: "carbon-fibers",
        text: "carbon fibers",
    },
    {
        key: "cardiac-arrhythmia",
        value: "cardiac-arrhythmia",
        text: "cardiac arrhythmia",
    },
    {
        key: "cardiology",
        value: "cardiology",
        text: "cardiology",
    },
    {
        key: "cardiovascular-diseases",
        value: "cardiovascular-diseases",
        text: "cardiovascular diseases",
    },
    {
        key: "cartography",
        value: "cartography",
        text: "cartography",
    },
    {
        key: "catalysis",
        value: "catalysis",
        text: "catalysis",
    },
    {
        key: "cavity-optomechanics",
        value: "cavity-optomechanics",
        text: "cavity optomechanics",
    },
    {
        key: "celestial-mechanics",
        value: "celestial-mechanics",
        text: "celestial mechanics",
    },
    {
        key: "cell-biology",
        value: "cell-biology",
        text: "cell biology",
    },
    {
        key: "cell-metabolism",
        value: "cell-metabolism",
        text: "cell metabolism",
    },
    {
        key: "cell-polarity",
        value: "cell-polarity",
        text: "cell polarity",
    },
    {
        key: "cell-signaling",
        value: "cell-signaling",
        text: "cell signaling",
    },
    {
        key: "cells-technologies",
        value: "cells-technologies",
        text: "cells technologies",
    },
    {
        key: "census",
        value: "census",
        text: "census",
    },
    {
        key: "ceramics",
        value: "ceramics",
        text: "ceramics",
    },
    {
        key: "cereals",
        value: "cereals",
        text: "cereals",
    },
    {
        key: "cerebrovascular-diseases",
        value: "cerebrovascular-diseases",
        text: "cerebrovascular diseases",
    },
    {
        key: "cervical-cancer",
        value: "cervical-cancer",
        text: "cervical cancer",
    },
    {
        key: "cetology",
        value: "cetology",
        text: "cetology",
    },
    {
        key: "chemical-engineering",
        value: "chemical-engineering",
        text: "chemical engineering",
    },
    {
        key: "chemical-process-engineering",
        value: "chemical-process-engineering",
        text: "chemical process engineering",
    },
    {
        key: "chemical-sciences",
        value: "chemical-sciences",
        text: "chemical sciences",
    },
    {
        key: "childbirth",
        value: "childbirth",
        text: "childbirth",
    },
    {
        key: "christianity",
        value: "christianity",
        text: "christianity",
    },
    {
        key: "chromosomes",
        value: "chromosomes",
        text: "chromosomes",
    },
    {
        key: "cinematography",
        value: "cinematography",
        text: "cinematography",
    },
    {
        key: "civil-engineering",
        value: "civil-engineering",
        text: "civil engineering",
    },
    {
        key: "civil-society",
        value: "civil-society",
        text: "civil society",
    },
    {
        key: "classical-mechanics",
        value: "classical-mechanics",
        text: "classical mechanics",
    },
    {
        key: "climatic-changes",
        value: "climatic-changes",
        text: "climatic changes",
    },
    {
        key: "climatic-zones",
        value: "climatic-zones",
        text: "climatic zones",
    },
    {
        key: "climatology",
        value: "climatology",
        text: "climatology",
    },
    {
        key: "clinical-medicine",
        value: "clinical-medicine",
        text: "clinical medicine",
    },
    {
        key: "clinical-microbiology",
        value: "clinical-microbiology",
        text: "clinical microbiology",
    },
    {
        key: "clinical-neurology",
        value: "clinical-neurology",
        text: "clinical neurology",
    },
    {
        key: "coal",
        value: "coal",
        text: "coal",
    },
    {
        key: "coastal-and-estuarine-hydraulics",
        value: "coastal-and-estuarine-hydraulics",
        text: "coastal and estuarine hydraulics",
    },
    {
        key: "coastal-ecosystems",
        value: "coastal-ecosystems",
        text: "coastal ecosystems",
    },
    {
        key: "coastal-geography",
        value: "coastal-geography",
        text: "coastal geography",
    },
    {
        key: "coating-and-films",
        value: "coating-and-films",
        text: "coating and films",
    },
    {
        key: "cognitive-neuroscience",
        value: "cognitive-neuroscience",
        text: "cognitive neuroscience",
    },
    {
        key: "cognitive-psychology",
        value: "cognitive-psychology",
        text: "cognitive psychology",
    },
    {
        key: "cognitive-radio",
        value: "cognitive-radio",
        text: "cognitive radio",
    },
    {
        key: "cognitive-robots",
        value: "cognitive-robots",
        text: "cognitive robots",
    },
    {
        key: "colorectal-cancer",
        value: "colorectal-cancer",
        text: "colorectal cancer",
    },
    {
        key: "colors",
        value: "colors",
        text: "colors",
    },
    {
        key: "combinatorics",
        value: "combinatorics",
        text: "combinatorics",
    },
    {
        key: "combined-heat-and-power",
        value: "combined-heat-and-power",
        text: "combined heat and power",
    },
    {
        key: "comets",
        value: "comets",
        text: "comets",
    },
    {
        key: "commerce",
        value: "commerce",
        text: "commerce",
    },
    {
        key: "commutative-algebra",
        value: "commutative-algebra",
        text: "commutative algebra",
    },
    {
        key: "comparative-morphology",
        value: "comparative-morphology",
        text: "comparative morphology",
    },
    {
        key: "complex-analysis",
        value: "complex-analysis",
        text: "complex analysis",
    },
    {
        key: "composites",
        value: "composites",
        text: "composites",
    },
    {
        key: "compost",
        value: "compost",
        text: "compost",
    },
    {
        key: "compressed-sensing",
        value: "compressed-sensing",
        text: "compressed sensing",
    },
    {
        key: "computational-creativity",
        value: "computational-creativity",
        text: "computational creativity",
    },
    {
        key: "computational-fluid-dynamics",
        value: "computational-fluid-dynamics",
        text: "computational fluid dynamics",
    },
    {
        key: "computational-intelligence",
        value: "computational-intelligence",
        text: "computational intelligence",
    },
    {
        key: "computational-neuroscience",
        value: "computational-neuroscience",
        text: "computational neuroscience",
    },
    {
        key: "computational-science",
        value: "computational-science",
        text: "computational science",
    },
    {
        key: "computational-topology",
        value: "computational-topology",
        text: "computational topology",
    },
    {
        key: "computed-tomography",
        value: "computed-tomography",
        text: "computed tomography",
    },
    {
        key: "computer-and-information-sciences",
        value: "computer-and-information-sciences",
        text: "computer and information sciences",
    },
    {
        key: "computer-hardware",
        value: "computer-hardware",
        text: "computer hardware",
    },
    {
        key: "computer-processors",
        value: "computer-processors",
        text: "computer processors",
    },
    {
        key: "computer-security",
        value: "computer-security",
        text: "computer security",
    },
    {
        key: "computer-vision",
        value: "computer-vision",
        text: "computer vision",
    },
    {
        key: "concentrated-solar-power",
        value: "concentrated-solar-power",
        text: "concentrated solar power",
    },
    {
        key: "condensed-matter-physics",
        value: "condensed-matter-physics",
        text: "condensed matter physics",
    },
    {
        key: "confocal-microscopy",
        value: "confocal-microscopy",
        text: "confocal microscopy",
    },
    {
        key: "constitutional-law",
        value: "constitutional-law",
        text: "constitutional law",
    },
    {
        key: "construction-engineering",
        value: "construction-engineering",
        text: "construction engineering",
    },
    {
        key: "contemporary-history",
        value: "contemporary-history",
        text: "contemporary history",
    },
    {
        key: "contemporary-philosophy",
        value: "contemporary-philosophy",
        text: "contemporary philosophy",
    },
    {
        key: "continuous-glucose-monitors",
        value: "continuous-glucose-monitors",
        text: "continuous glucose monitors",
    },
    {
        key: "control-engineering",
        value: "control-engineering",
        text: "control engineering",
    },
    {
        key: "control-systems",
        value: "control-systems",
        text: "control systems",
    },
    {
        key: "coppicing",
        value: "coppicing",
        text: "coppicing",
    },
    {
        key: "coronaviruses",
        value: "coronaviruses",
        text: "coronaviruses",
    },
    {
        key: "corruption",
        value: "corruption",
        text: "corruption",
    },
    {
        key: "cosmochemistry",
        value: "cosmochemistry",
        text: "cosmochemistry",
    },
    {
        key: "criminology",
        value: "criminology",
        text: "criminology",
    },
    {
        key: "crisis-management",
        value: "crisis-management",
        text: "crisis management",
    },
    {
        key: "critical-care-medicine",
        value: "critical-care-medicine",
        text: "critical care medicine",
    },
    {
        key: "cryptography",
        value: "cryptography",
        text: "cryptography",
    },
    {
        key: "crystallography",
        value: "crystallography",
        text: "crystallography",
    },
    {
        key: "crystals",
        value: "crystals",
        text: "crystals",
    },
    {
        key: "cultural-and-economic-geography",
        value: "cultural-and-economic-geography",
        text: "cultural and economic geography",
    },
    {
        key: "cultural-anthropology",
        value: "cultural-anthropology",
        text: "cultural anthropology",
    },
    {
        key: "cytology",
        value: "cytology",
        text: "cytology",
    },
    {
        key: "dairy",
        value: "dairy",
        text: "dairy",
    },
    {
        key: "dark-matter",
        value: "dark-matter",
        text: "dark matter",
    },
    {
        key: "data-exchange",
        value: "data-exchange",
        text: "data exchange",
    },
    {
        key: "data-mining",
        value: "data-mining",
        text: "data mining",
    },
    {
        key: "data-networks",
        value: "data-networks",
        text: "data networks",
    },
    {
        key: "data-processing",
        value: "data-processing",
        text: "data processing",
    },
    {
        key: "data-protection",
        value: "data-protection",
        text: "data protection",
    },
    {
        key: "data-science",
        value: "data-science",
        text: "data science",
    },
    {
        key: "databases",
        value: "databases",
        text: "databases",
    },
    {
        key: "deep-learning",
        value: "deep-learning",
        text: "deep learning",
    },
    {
        key: "dementia",
        value: "dementia",
        text: "dementia",
    },
    {
        key: "democracy",
        value: "democracy",
        text: "democracy",
    },
    {
        key: "demography",
        value: "demography",
        text: "demography",
    },
    {
        key: "dendrochronology",
        value: "dendrochronology",
        text: "dendrochronology",
    },
    {
        key: "dendroclimatology",
        value: "dendroclimatology",
        text: "dendroclimatology",
    },
    {
        key: "dendrology",
        value: "dendrology",
        text: "dendrology",
    },
    {
        key: "dental-implantology",
        value: "dental-implantology",
        text: "dental implantology",
    },
    {
        key: "dermatology",
        value: "dermatology",
        text: "dermatology",
    },
    {
        key: "desalination",
        value: "desalination",
        text: "desalination",
    },
    {
        key: "developmental-biology",
        value: "developmental-biology",
        text: "developmental biology",
    },
    {
        key: "developmental-psychology",
        value: "developmental-psychology",
        text: "developmental psychology",
    },
    {
        key: "device-drivers",
        value: "device-drivers",
        text: "device drivers",
    },
    {
        key: "diabetes",
        value: "diabetes",
        text: "diabetes",
    },
    {
        key: "diabetic-nephropathy",
        value: "diabetic-nephropathy",
        text: "diabetic nephropathy",
    },
    {
        key: "diagnostic-imaging",
        value: "diagnostic-imaging",
        text: "diagnostic imaging",
    },
    {
        key: "diagnostic-technologies",
        value: "diagnostic-technologies",
        text: "diagnostic technologies",
    },
    {
        key: "didactics",
        value: "didactics",
        text: "didactics",
    },
    {
        key: "dietetics",
        value: "dietetics",
        text: "dietetics",
    },
    {
        key: "differential-equations",
        value: "differential-equations",
        text: "differential equations",
    },
    {
        key: "digital-electronics",
        value: "digital-electronics",
        text: "digital electronics",
    },
    {
        key: "digital-humanities",
        value: "digital-humanities",
        text: "digital humanities",
    },
    {
        key: "discrete-mathematics",
        value: "discrete-mathematics",
        text: "discrete mathematics",
    },
    {
        key: "distillation",
        value: "distillation",
        text: "distillation",
    },
    {
        key: "domestic-animals",
        value: "domestic-animals",
        text: "domestic animals",
    },
    {
        key: "drainage-basins",
        value: "drainage-basins",
        text: "drainage basins",
    },
    {
        key: "dramaturgy",
        value: "dramaturgy",
        text: "dramaturgy",
    },
    {
        key: "drinking-water-treatment-processes",
        value: "drinking-water-treatment-processes",
        text: "drinking water treatment processes",
    },
    {
        key: "drive-by-wire",
        value: "drive-by-wire",
        text: "drive by wire",
    },
    {
        key: "drones",
        value: "drones",
        text: "drones",
    },
    {
        key: "drug-allergy",
        value: "drug-allergy",
        text: "drug allergy",
    },
    {
        key: "drug-discovery",
        value: "drug-discovery",
        text: "drug discovery",
    },
    {
        key: "drug-resistance",
        value: "drug-resistance",
        text: "drug resistance",
    },
    {
        key: "drug-safety",
        value: "drug-safety",
        text: "drug safety",
    },
    {
        key: "duchenne-muscular-dystrophy",
        value: "duchenne-muscular-dystrophy",
        text: "duchenne muscular dystrophy",
    },
    {
        key: "dynamical-systems",
        value: "dynamical-systems",
        text: "dynamical systems",
    },
    {
        key: "e-governance",
        value: "e-governance",
        text: "e-governance",
    },
    {
        key: "ecommerce",
        value: "ecommerce",
        text: "eCommerce",
    },
    {
        key: "ehealth",
        value: "ehealth",
        text: "eHealth",
    },
    {
        key: "earth-and-related-environmental-sciences",
        value: "earth-and-related-environmental-sciences",
        text: "earth and related environmental sciences",
    },
    {
        key: "earthquake-engineering",
        value: "earthquake-engineering",
        text: "earthquake engineering",
    },
    {
        key: "eastern-religions",
        value: "eastern-religions",
        text: "eastern religions",
    },
    {
        key: "ebola",
        value: "ebola",
        text: "ebola",
    },
    {
        key: "ecohydrology",
        value: "ecohydrology",
        text: "ecohydrology",
    },
    {
        key: "ecology",
        value: "ecology",
        text: "ecology",
    },
    {
        key: "econometrics",
        value: "econometrics",
        text: "econometrics",
    },
    {
        key: "economic-impact-of-epidemics",
        value: "economic-impact-of-epidemics",
        text: "economic impact of epidemics",
    },
    {
        key: "economics",
        value: "economics",
        text: "economics",
    },
    {
        key: "economics-and-business",
        value: "economics-and-business",
        text: "economics and business",
    },
    {
        key: "ecosystems",
        value: "ecosystems",
        text: "ecosystems",
    },
    {
        key: "edaphology",
        value: "edaphology",
        text: "edaphology",
    },
    {
        key: "educational-sciences",
        value: "educational-sciences",
        text: "educational sciences",
    },
    {
        key: "el-ni\u00f1o",
        value: "el-ni\u00f1o",
        text: "el ni\u00f1o",
    },
    {
        key: "elections",
        value: "elections",
        text: "elections",
    },
    {
        key: "electric-batteries",
        value: "electric-batteries",
        text: "electric batteries",
    },
    {
        key: "electric-energy",
        value: "electric-energy",
        text: "electric energy",
    },
    {
        key: "electric-power-distribution",
        value: "electric-power-distribution",
        text: "electric power distribution",
    },
    {
        key: "electric-power-generation",
        value: "electric-power-generation",
        text: "electric power generation",
    },
    {
        key: "electric-power-transmission",
        value: "electric-power-transmission",
        text: "electric power transmission",
    },
    {
        key: "electric-vehicles",
        value: "electric-vehicles",
        text: "electric vehicles",
    },
    {
        key: "electrical-engineering",
        value: "electrical-engineering",
        text: "electrical engineering",
    },
    {
        key: "electrical-engineering,-electronic-engineering,-information-engineering",
        value: "electrical-engineering,-electronic-engineering,-information-engineering",
        text: "electrical engineering, electronic engineering, information engineering",
    },
    {
        key: "electrocatalysis",
        value: "electrocatalysis",
        text: "electrocatalysis",
    },
    {
        key: "electrochemistry",
        value: "electrochemistry",
        text: "electrochemistry",
    },
    {
        key: "electrodialysis",
        value: "electrodialysis",
        text: "electrodialysis",
    },
    {
        key: "electrolysis",
        value: "electrolysis",
        text: "electrolysis",
    },
    {
        key: "electromagnetism",
        value: "electromagnetism",
        text: "electromagnetism",
    },
    {
        key: "electromagnetism-and-electronics",
        value: "electromagnetism-and-electronics",
        text: "electromagnetism and electronics",
    },
    {
        key: "electron-microscopy",
        value: "electron-microscopy",
        text: "electron microscopy",
    },
    {
        key: "electronic-engineering",
        value: "electronic-engineering",
        text: "electronic engineering",
    },
    {
        key: "electrophoresis",
        value: "electrophoresis",
        text: "electrophoresis",
    },
    {
        key: "electroporation",
        value: "electroporation",
        text: "electroporation",
    },
    {
        key: "embryology",
        value: "embryology",
        text: "embryology",
    },
    {
        key: "emergency-medicine",
        value: "emergency-medicine",
        text: "emergency medicine",
    },
    {
        key: "emission-spectroscopy",
        value: "emission-spectroscopy",
        text: "emission spectroscopy",
    },
    {
        key: "employment",
        value: "employment",
        text: "employment",
    },
    {
        key: "endocrinology",
        value: "endocrinology",
        text: "endocrinology",
    },
    {
        key: "energy-and-fuels",
        value: "energy-and-fuels",
        text: "energy and fuels",
    },
    {
        key: "energy-conversion",
        value: "energy-conversion",
        text: "energy conversion",
    },
    {
        key: "entomology",
        value: "entomology",
        text: "entomology",
    },
    {
        key: "entrepreneurship",
        value: "entrepreneurship",
        text: "entrepreneurship",
    },
    {
        key: "environmental-biotechnology",
        value: "environmental-biotechnology",
        text: "environmental biotechnology",
    },
    {
        key: "environmental-engineering",
        value: "environmental-engineering",
        text: "environmental engineering",
    },
    {
        key: "environmental-sciences",
        value: "environmental-sciences",
        text: "environmental sciences",
    },
    {
        key: "enzymes",
        value: "enzymes",
        text: "enzymes",
    },
    {
        key: "epidemics-prevention",
        value: "epidemics-prevention",
        text: "epidemics prevention",
    },
    {
        key: "epidemiology",
        value: "epidemiology",
        text: "epidemiology",
    },
    {
        key: "epigenetics",
        value: "epigenetics",
        text: "epigenetics",
    },
    {
        key: "epilepsy",
        value: "epilepsy",
        text: "epilepsy",
    },
    {
        key: "epistemology",
        value: "epistemology",
        text: "epistemology",
    },
    {
        key: "ergonomics",
        value: "ergonomics",
        text: "ergonomics",
    },
    {
        key: "essays",
        value: "essays",
        text: "essays",
    },
    {
        key: "ethical-principles",
        value: "ethical-principles",
        text: "ethical principles",
    },
    {
        key: "ethical-theories",
        value: "ethical-theories",
        text: "ethical theories",
    },
    {
        key: "ethics",
        value: "ethics",
        text: "ethics",
    },
    {
        key: "ethnoarchaeology",
        value: "ethnoarchaeology",
        text: "ethnoarchaeology",
    },
    {
        key: "ethnolichenology",
        value: "ethnolichenology",
        text: "ethnolichenology",
    },
    {
        key: "ethnology",
        value: "ethnology",
        text: "ethnology",
    },
    {
        key: "ethnomusicology",
        value: "ethnomusicology",
        text: "ethnomusicology",
    },
    {
        key: "ethnomycology",
        value: "ethnomycology",
        text: "ethnomycology",
    },
    {
        key: "ethology",
        value: "ethology",
        text: "ethology",
    },
    {
        key: "eukaryotic-genomes",
        value: "eukaryotic-genomes",
        text: "eukaryotic genomes",
    },
    {
        key: "evolutionary-biology",
        value: "evolutionary-biology",
        text: "evolutionary biology",
    },
    {
        key: "evolutionary-ecology",
        value: "evolutionary-ecology",
        text: "evolutionary ecology",
    },
    {
        key: "exoplanetology",
        value: "exoplanetology",
        text: "exoplanetology",
    },
    {
        key: "expert-systems",
        value: "expert-systems",
        text: "expert systems",
    },
    {
        key: "extragalactic-astronomy",
        value: "extragalactic-astronomy",
        text: "extragalactic astronomy",
    },
    {
        key: "family-planning",
        value: "family-planning",
        text: "family planning",
    },
    {
        key: "family-studies",
        value: "family-studies",
        text: "family studies",
    },
    {
        key: "fermentation",
        value: "fermentation",
        text: "fermentation",
    },
    {
        key: "fermions",
        value: "fermions",
        text: "fermions",
    },
    {
        key: "fertility",
        value: "fertility",
        text: "fertility",
    },
    {
        key: "fetal-medicine",
        value: "fetal-medicine",
        text: "fetal medicine",
    },
    {
        key: "fiber-optic-network",
        value: "fiber-optic-network",
        text: "fiber-optic network",
    },
    {
        key: "fibers",
        value: "fibers",
        text: "fibers",
    },
    {
        key: "fibre-optics",
        value: "fibre-optics",
        text: "fibre optics",
    },
    {
        key: "fisheries",
        value: "fisheries",
        text: "fisheries",
    },
    {
        key: "fixed-wireless-network",
        value: "fixed-wireless-network",
        text: "fixed wireless network",
    },
    {
        key: "flood-risk-management",
        value: "flood-risk-management",
        text: "flood risk management",
    },
    {
        key: "floriculture",
        value: "floriculture",
        text: "floriculture",
    },
    {
        key: "fluid-dynamics",
        value: "fluid-dynamics",
        text: "fluid dynamics",
    },
    {
        key: "fluid-mechanics",
        value: "fluid-mechanics",
        text: "fluid mechanics",
    },
    {
        key: "fluid-statics",
        value: "fluid-statics",
        text: "fluid statics",
    },
    {
        key: "fluorescence-lifetime-imaging",
        value: "fluorescence-lifetime-imaging",
        text: "fluorescence lifetime imaging",
    },
    {
        key: "fodder",
        value: "fodder",
        text: "fodder",
    },
    {
        key: "folklore",
        value: "folklore",
        text: "folklore",
    },
    {
        key: "food-allergy",
        value: "food-allergy",
        text: "food allergy",
    },
    {
        key: "food-packaging",
        value: "food-packaging",
        text: "food packaging",
    },
    {
        key: "food-safety",
        value: "food-safety",
        text: "food safety",
    },
    {
        key: "food-technology",
        value: "food-technology",
        text: "food technology",
    },
    {
        key: "foreign-policy",
        value: "foreign-policy",
        text: "foreign policy",
    },
    {
        key: "forensic-sciences",
        value: "forensic-sciences",
        text: "forensic sciences",
    },
    {
        key: "forestry",
        value: "forestry",
        text: "forestry",
    },
    {
        key: "fossil-energy",
        value: "fossil-energy",
        text: "fossil energy",
    },
    {
        key: "fourier-analysis",
        value: "fourier-analysis",
        text: "fourier analysis",
    },
    {
        key: "freight-transport",
        value: "freight-transport",
        text: "freight transport",
    },
    {
        key: "freshwater-biology",
        value: "freshwater-biology",
        text: "freshwater biology",
    },
    {
        key: "freshwater-ecosystems",
        value: "freshwater-ecosystems",
        text: "freshwater ecosystems",
    },
    {
        key: "fruit-growing",
        value: "fruit-growing",
        text: "fruit growing",
    },
    {
        key: "fuel-cells",
        value: "fuel-cells",
        text: "fuel cells",
    },
    {
        key: "functional-equations",
        value: "functional-equations",
        text: "functional equations",
    },
    {
        key: "functional-morphology",
        value: "functional-morphology",
        text: "functional morphology",
    },
    {
        key: "galactic-astronomy",
        value: "galactic-astronomy",
        text: "galactic astronomy",
    },
    {
        key: "galaxy-evolution",
        value: "galaxy-evolution",
        text: "galaxy evolution",
    },
    {
        key: "game-theory",
        value: "game-theory",
        text: "game theory",
    },
    {
        key: "gamma-ray-astronomy",
        value: "gamma-ray-astronomy",
        text: "gamma-ray astronomy",
    },
    {
        key: "gas-giants",
        value: "gas-giants",
        text: "gas giants",
    },
    {
        key: "gastroenterology",
        value: "gastroenterology",
        text: "gastroenterology",
    },
    {
        key: "gender-equality",
        value: "gender-equality",
        text: "gender equality",
    },
    {
        key: "gender-inequality",
        value: "gender-inequality",
        text: "gender inequality",
    },
    {
        key: "gender-studies",
        value: "gender-studies",
        text: "gender studies",
    },
    {
        key: "gene-therapy",
        value: "gene-therapy",
        text: "gene therapy",
    },
    {
        key: "general-language-studies",
        value: "general-language-studies",
        text: "general language studies",
    },
    {
        key: "general-medicine",
        value: "general-medicine",
        text: "general medicine",
    },
    {
        key: "genetic-engineering",
        value: "genetic-engineering",
        text: "genetic engineering",
    },
    {
        key: "genetics",
        value: "genetics",
        text: "genetics",
    },
    {
        key: "genomes",
        value: "genomes",
        text: "genomes",
    },
    {
        key: "geochemistry",
        value: "geochemistry",
        text: "geochemistry",
    },
    {
        key: "geochronology",
        value: "geochronology",
        text: "geochronology",
    },
    {
        key: "geographic-information-systems",
        value: "geographic-information-systems",
        text: "geographic information systems",
    },
    {
        key: "geological-engineering",
        value: "geological-engineering",
        text: "geological engineering",
    },
    {
        key: "geology",
        value: "geology",
        text: "geology",
    },
    {
        key: "geometry",
        value: "geometry",
        text: "geometry",
    },
    {
        key: "geomorphology",
        value: "geomorphology",
        text: "geomorphology",
    },
    {
        key: "geophysics",
        value: "geophysics",
        text: "geophysics",
    },
    {
        key: "geotechnics",
        value: "geotechnics",
        text: "geotechnics",
    },
    {
        key: "geothermal-energy",
        value: "geothermal-energy",
        text: "geothermal energy",
    },
    {
        key: "gerontology",
        value: "gerontology",
        text: "gerontology",
    },
    {
        key: "giant-planets",
        value: "giant-planets",
        text: "giant planets",
    },
    {
        key: "glacial-geology",
        value: "glacial-geology",
        text: "glacial geology",
    },
    {
        key: "glaciology",
        value: "glaciology",
        text: "glaciology",
    },
    {
        key: "glaucoma",
        value: "glaucoma",
        text: "glaucoma",
    },
    {
        key: "global-navigation-satellite-system",
        value: "global-navigation-satellite-system",
        text: "global navigation satellite system",
    },
    {
        key: "globalization",
        value: "globalization",
        text: "globalization",
    },
    {
        key: "gluons",
        value: "gluons",
        text: "gluons",
    },
    {
        key: "governance",
        value: "governance",
        text: "governance",
    },
    {
        key: "government-systems",
        value: "government-systems",
        text: "government systems",
    },
    {
        key: "graft-versus-host-disease",
        value: "graft-versus-host-disease",
        text: "graft versus host disease",
    },
    {
        key: "grains-and-oilseeds",
        value: "grains-and-oilseeds",
        text: "grains and oilseeds",
    },
    {
        key: "graph-theory",
        value: "graph-theory",
        text: "graph theory",
    },
    {
        key: "graphene",
        value: "graphene",
        text: "graphene",
    },
    {
        key: "graphic-design",
        value: "graphic-design",
        text: "graphic design",
    },
    {
        key: "gravitational-waves",
        value: "gravitational-waves",
        text: "gravitational waves",
    },
    {
        key: "gynaecology",
        value: "gynaecology",
        text: "gynaecology",
    },
    {
        key: "halogens",
        value: "halogens",
        text: "halogens",
    },
    {
        key: "head-and-neck-cancer",
        value: "head-and-neck-cancer",
        text: "head and neck cancer",
    },
    {
        key: "health-care-sciences",
        value: "health-care-sciences",
        text: "health care sciences",
    },
    {
        key: "health-care-services",
        value: "health-care-services",
        text: "health care services",
    },
    {
        key: "health-economics",
        value: "health-economics",
        text: "health economics",
    },
    {
        key: "health-sciences",
        value: "health-sciences",
        text: "health sciences",
    },
    {
        key: "heat-engineering",
        value: "heat-engineering",
        text: "heat engineering",
    },
    {
        key: "hematology",
        value: "hematology",
        text: "hematology",
    },
    {
        key: "hepatitis-b",
        value: "hepatitis-b",
        text: "hepatitis B",
    },
    {
        key: "hepatitis-c",
        value: "hepatitis-c",
        text: "hepatitis C",
    },
    {
        key: "hepatology",
        value: "hepatology",
        text: "hepatology",
    },
    {
        key: "heredity",
        value: "heredity",
        text: "heredity",
    },
    {
        key: "heterocyclic-compounds",
        value: "heterocyclic-compounds",
        text: "heterocyclic compounds",
    },
    {
        key: "heuristic-programming",
        value: "heuristic-programming",
        text: "heuristic programming",
    },
    {
        key: "higgs-bosons",
        value: "higgs-bosons",
        text: "higgs bosons",
    },
    {
        key: "highway-engineering",
        value: "highway-engineering",
        text: "highway engineering",
    },
    {
        key: "histology",
        value: "histology",
        text: "histology",
    },
    {
        key: "history",
        value: "history",
        text: "history",
    },
    {
        key: "history-and-archaeology",
        value: "history-and-archaeology",
        text: "history and archaeology",
    },
    {
        key: "history-of-astronomy",
        value: "history-of-astronomy",
        text: "history of astronomy",
    },
    {
        key: "history-of-islam",
        value: "history-of-islam",
        text: "history of islam",
    },
    {
        key: "history-of-literature",
        value: "history-of-literature",
        text: "history of literature",
    },
    {
        key: "history-of-medicine",
        value: "history-of-medicine",
        text: "history of medicine",
    },
    {
        key: "history-of-philosophy",
        value: "history-of-philosophy",
        text: "history of philosophy",
    },
    {
        key: "home-automation",
        value: "home-automation",
        text: "home automation",
    },
    {
        key: "homeostasis",
        value: "homeostasis",
        text: "homeostasis",
    },
    {
        key: "horticulture",
        value: "horticulture",
        text: "horticulture",
    },
    {
        key: "human-migrations",
        value: "human-migrations",
        text: "human migrations",
    },
    {
        key: "human-rights",
        value: "human-rights",
        text: "human rights",
    },
    {
        key: "human-rights-law",
        value: "human-rights-law",
        text: "human rights law",
    },
    {
        key: "human-rights-violations",
        value: "human-rights-violations",
        text: "human rights violations",
    },
    {
        key: "human-trafficking",
        value: "human-trafficking",
        text: "human trafficking",
    },
    {
        key: "hybrid-energy",
        value: "hybrid-energy",
        text: "hybrid energy",
    },
    {
        key: "hydraulic-engineering",
        value: "hydraulic-engineering",
        text: "hydraulic engineering",
    },
    {
        key: "hydrocarbons",
        value: "hydrocarbons",
        text: "hydrocarbons",
    },
    {
        key: "hydroelectricity",
        value: "hydroelectricity",
        text: "hydroelectricity",
    },
    {
        key: "hydrogen-energy",
        value: "hydrogen-energy",
        text: "hydrogen energy",
    },
    {
        key: "hydrogeology",
        value: "hydrogeology",
        text: "hydrogeology",
    },
    {
        key: "hydroinformatics",
        value: "hydroinformatics",
        text: "hydroinformatics",
    },
    {
        key: "hydrology",
        value: "hydrology",
        text: "hydrology",
    },
    {
        key: "hydrometeorology",
        value: "hydrometeorology",
        text: "hydrometeorology",
    },
    {
        key: "ice-giants",
        value: "ice-giants",
        text: "ice giants",
    },
    {
        key: "ichthyology",
        value: "ichthyology",
        text: "ichthyology",
    },
    {
        key: "ideologies",
        value: "ideologies",
        text: "ideologies",
    },
    {
        key: "igneous-petrology",
        value: "igneous-petrology",
        text: "igneous petrology",
    },
    {
        key: "immunisation",
        value: "immunisation",
        text: "immunisation",
    },
    {
        key: "immunology",
        value: "immunology",
        text: "immunology",
    },
    {
        key: "immunotherapy",
        value: "immunotherapy",
        text: "immunotherapy",
    },
    {
        key: "implants",
        value: "implants",
        text: "implants",
    },
    {
        key: "inclusive-education",
        value: "inclusive-education",
        text: "inclusive education",
    },
    {
        key: "industrial-biotechnology",
        value: "industrial-biotechnology",
        text: "industrial biotechnology",
    },
    {
        key: "industrial-crops",
        value: "industrial-crops",
        text: "industrial crops",
    },
    {
        key: "industrial-relations",
        value: "industrial-relations",
        text: "industrial relations",
    },
    {
        key: "inertial-navigation-system",
        value: "inertial-navigation-system",
        text: "inertial navigation system",
    },
    {
        key: "infectious-diseases",
        value: "infectious-diseases",
        text: "infectious diseases",
    },
    {
        key: "inflammatory-bowel-disease",
        value: "inflammatory-bowel-disease",
        text: "inflammatory bowel disease",
    },
    {
        key: "inflammatory-diseases",
        value: "inflammatory-diseases",
        text: "inflammatory diseases",
    },
    {
        key: "influenza",
        value: "influenza",
        text: "influenza",
    },
    {
        key: "information-engineering",
        value: "information-engineering",
        text: "information engineering",
    },
    {
        key: "infrared-astronomy",
        value: "infrared-astronomy",
        text: "infrared astronomy",
    },
    {
        key: "innovation-management",
        value: "innovation-management",
        text: "innovation management",
    },
    {
        key: "inorganic-chemistry",
        value: "inorganic-chemistry",
        text: "inorganic chemistry",
    },
    {
        key: "inorganic-compounds",
        value: "inorganic-compounds",
        text: "inorganic compounds",
    },
    {
        key: "inquiry-based-learning",
        value: "inquiry-based-learning",
        text: "inquiry based learning",
    },
    {
        key: "integrative-and-complementary-medicine",
        value: "integrative-and-complementary-medicine",
        text: "integrative and complementary medicine",
    },
    {
        key: "intelligent-transport-systems",
        value: "intelligent-transport-systems",
        text: "intelligent transport systems",
    },
    {
        key: "internal-medicine",
        value: "internal-medicine",
        text: "internal medicine",
    },
    {
        key: "international-law",
        value: "international-law",
        text: "international law",
    },
    {
        key: "international-protection-of-human-rights",
        value: "international-protection-of-human-rights",
        text: "international protection of human rights",
    },
    {
        key: "internet",
        value: "internet",
        text: "internet",
    },
    {
        key: "internet-access",
        value: "internet-access",
        text: "internet access",
    },
    {
        key: "internet-of-things",
        value: "internet-of-things",
        text: "internet of things",
    },
    {
        key: "internet-protocols",
        value: "internet-protocols",
        text: "internet protocols",
    },
    {
        key: "invasive-species",
        value: "invasive-species",
        text: "invasive species",
    },
    {
        key: "invertebrate-zoology",
        value: "invertebrate-zoology",
        text: "invertebrate zoology",
    },
    {
        key: "irrigation",
        value: "irrigation",
        text: "irrigation",
    },
    {
        key: "islam",
        value: "islam",
        text: "islam",
    },
    {
        key: "islamic-schools",
        value: "islamic-schools",
        text: "islamic schools",
    },
    {
        key: "isotope-geochemistry",
        value: "isotope-geochemistry",
        text: "isotope geochemistry",
    },
    {
        key: "isotope-hydrology",
        value: "isotope-hydrology",
        text: "isotope hydrology",
    },
    {
        key: "journalism",
        value: "journalism",
        text: "journalism",
    },
    {
        key: "judaism",
        value: "judaism",
        text: "judaism",
    },
    {
        key: "ketones",
        value: "ketones",
        text: "ketones",
    },
    {
        key: "kidney-diseases",
        value: "kidney-diseases",
        text: "kidney diseases",
    },
    {
        key: "knot-theory",
        value: "knot-theory",
        text: "knot theory",
    },
    {
        key: "knowledge-engineering",
        value: "knowledge-engineering",
        text: "knowledge engineering",
    },
    {
        key: "knowledge-organization",
        value: "knowledge-organization",
        text: "knowledge organization",
    },
    {
        key: "lab-on-a-chip",
        value: "lab-on-a-chip",
        text: "lab on a chip",
    },
    {
        key: "laboratory-samples-analysis",
        value: "laboratory-samples-analysis",
        text: "laboratory samples analysis",
    },
    {
        key: "land-based-treatment",
        value: "land-based-treatment",
        text: "land-based treatment",
    },
    {
        key: "landscape-ecology",
        value: "landscape-ecology",
        text: "landscape ecology",
    },
    {
        key: "languages-and-literature",
        value: "languages-and-literature",
        text: "languages and literature",
    },
    {
        key: "laser-physics",
        value: "laser-physics",
        text: "laser physics",
    },
    {
        key: "law",
        value: "law",
        text: "law",
    },
    {
        key: "law-enforcement",
        value: "law-enforcement",
        text: "law enforcement",
    },
    {
        key: "legumes",
        value: "legumes",
        text: "legumes",
    },
    {
        key: "leptons",
        value: "leptons",
        text: "leptons",
    },
    {
        key: "leukemia",
        value: "leukemia",
        text: "leukemia",
    },
    {
        key: "library-sciences",
        value: "library-sciences",
        text: "library sciences",
    },
    {
        key: "limnology",
        value: "limnology",
        text: "limnology",
    },
    {
        key: "linear-algebra",
        value: "linear-algebra",
        text: "linear algebra",
    },
    {
        key: "linguistics",
        value: "linguistics",
        text: "linguistics",
    },
    {
        key: "lipids",
        value: "lipids",
        text: "lipids",
    },
    {
        key: "liquid-crystals",
        value: "liquid-crystals",
        text: "liquid crystals",
    },
    {
        key: "liquid-fuels",
        value: "liquid-fuels",
        text: "liquid fuels",
    },
    {
        key: "literary-criticism",
        value: "literary-criticism",
        text: "literary criticism",
    },
    {
        key: "literary-genres",
        value: "literary-genres",
        text: "literary genres",
    },
    {
        key: "literary-theory",
        value: "literary-theory",
        text: "literary theory",
    },
    {
        key: "literature-studies",
        value: "literature-studies",
        text: "literature studies",
    },
    {
        key: "lithology",
        value: "lithology",
        text: "lithology",
    },
    {
        key: "liver-cancer",
        value: "liver-cancer",
        text: "liver cancer",
    },
    {
        key: "livestock-cloning",
        value: "livestock-cloning",
        text: "livestock cloning",
    },
    {
        key: "logarithmic-functions",
        value: "logarithmic-functions",
        text: "logarithmic functions",
    },
    {
        key: "lubrication",
        value: "lubrication",
        text: "lubrication",
    },
    {
        key: "lung-cancer",
        value: "lung-cancer",
        text: "lung cancer",
    },
    {
        key: "machine-learning",
        value: "machine-learning",
        text: "machine learning",
    },
    {
        key: "macroeconomics",
        value: "macroeconomics",
        text: "macroeconomics",
    },
    {
        key: "magnetic-resonance-imaging",
        value: "magnetic-resonance-imaging",
        text: "magnetic resonance imaging",
    },
    {
        key: "malaria",
        value: "malaria",
        text: "malaria",
    },
    {
        key: "malicious-software",
        value: "malicious-software",
        text: "malicious software",
    },
    {
        key: "mammalogy",
        value: "mammalogy",
        text: "mammalogy",
    },
    {
        key: "manufacturing-engineering",
        value: "manufacturing-engineering",
        text: "manufacturing engineering",
    },
    {
        key: "marine-biology",
        value: "marine-biology",
        text: "marine biology",
    },
    {
        key: "marine-energy",
        value: "marine-energy",
        text: "marine energy",
    },
    {
        key: "marker-assisted-selection",
        value: "marker-assisted-selection",
        text: "marker assisted selection",
    },
    {
        key: "mass-spectrometry",
        value: "mass-spectrometry",
        text: "mass spectrometry",
    },
    {
        key: "materials-engineering",
        value: "materials-engineering",
        text: "materials engineering",
    },
    {
        key: "mathematical-analysis",
        value: "mathematical-analysis",
        text: "mathematical analysis",
    },
    {
        key: "mathematical-logic",
        value: "mathematical-logic",
        text: "mathematical logic",
    },
    {
        key: "mathematical-model",
        value: "mathematical-model",
        text: "mathematical model",
    },
    {
        key: "mathematical-physics",
        value: "mathematical-physics",
        text: "mathematical physics",
    },
    {
        key: "mathematics",
        value: "mathematics",
        text: "mathematics",
    },
    {
        key: "mechanical-engineering",
        value: "mechanical-engineering",
        text: "mechanical engineering",
    },
    {
        key: "mechatronics",
        value: "mechatronics",
        text: "mechatronics",
    },
    {
        key: "media-and-communications",
        value: "media-and-communications",
        text: "media and communications",
    },
    {
        key: "medical-biotechnology",
        value: "medical-biotechnology",
        text: "medical biotechnology",
    },
    {
        key: "medical-engineering",
        value: "medical-engineering",
        text: "medical engineering",
    },
    {
        key: "medical-ethics",
        value: "medical-ethics",
        text: "medical ethics",
    },
    {
        key: "medical-genetics",
        value: "medical-genetics",
        text: "medical genetics",
    },
    {
        key: "medical-laboratory-technology",
        value: "medical-laboratory-technology",
        text: "medical laboratory technology",
    },
    {
        key: "medicinal-chemistry",
        value: "medicinal-chemistry",
        text: "medicinal chemistry",
    },
    {
        key: "medieval-history",
        value: "medieval-history",
        text: "medieval history",
    },
    {
        key: "medieval-philosophy",
        value: "medieval-philosophy",
        text: "medieval philosophy",
    },
    {
        key: "melanoma",
        value: "melanoma",
        text: "melanoma",
    },
    {
        key: "mental-processes",
        value: "mental-processes",
        text: "mental processes",
    },
    {
        key: "mesoscopic-physics",
        value: "mesoscopic-physics",
        text: "mesoscopic physics",
    },
    {
        key: "metabolic-engineering",
        value: "metabolic-engineering",
        text: "metabolic engineering",
    },
    {
        key: "metalloids",
        value: "metalloids",
        text: "metalloids",
    },
    {
        key: "metallurgy",
        value: "metallurgy",
        text: "metallurgy",
    },
    {
        key: "metamorphic-petrology",
        value: "metamorphic-petrology",
        text: "metamorphic petrology",
    },
    {
        key: "metaphysics",
        value: "metaphysics",
        text: "metaphysics",
    },
    {
        key: "meteorites",
        value: "meteorites",
        text: "meteorites",
    },
    {
        key: "meteorology",
        value: "meteorology",
        text: "meteorology",
    },
    {
        key: "meteors",
        value: "meteors",
        text: "meteors",
    },
    {
        key: "microbiology",
        value: "microbiology",
        text: "microbiology",
    },
    {
        key: "microeconomics",
        value: "microeconomics",
        text: "microeconomics",
    },
    {
        key: "microelectronics",
        value: "microelectronics",
        text: "microelectronics",
    },
    {
        key: "microfluidics",
        value: "microfluidics",
        text: "microfluidics",
    },
    {
        key: "microscopy",
        value: "microscopy",
        text: "microscopy",
    },
    {
        key: "microseisms",
        value: "microseisms",
        text: "microseisms",
    },
    {
        key: "microtechnology",
        value: "microtechnology",
        text: "microtechnology",
    },
    {
        key: "microwave-technology",
        value: "microwave-technology",
        text: "microwave technology",
    },
    {
        key: "mineralogy",
        value: "mineralogy",
        text: "mineralogy",
    },
    {
        key: "mining-and-mineral-processing",
        value: "mining-and-mineral-processing",
        text: "mining and mineral processing",
    },
    {
        key: "mobile-network",
        value: "mobile-network",
        text: "mobile network",
    },
    {
        key: "mobile-phones",
        value: "mobile-phones",
        text: "mobile phones",
    },
    {
        key: "mobile-radio",
        value: "mobile-radio",
        text: "mobile radio",
    },
    {
        key: "modeling-of-diseases-spread",
        value: "modeling-of-diseases-spread",
        text: "modeling of diseases spread",
    },
    {
        key: "modern-and-contemporary-art",
        value: "modern-and-contemporary-art",
        text: "modern and contemporary art",
    },
    {
        key: "modern-history",
        value: "modern-history",
        text: "modern history",
    },
    {
        key: "modern-philosophy",
        value: "modern-philosophy",
        text: "modern philosophy",
    },
    {
        key: "molecular-and-chemical-physics",
        value: "molecular-and-chemical-physics",
        text: "molecular and chemical physics",
    },
    {
        key: "molecular-biology",
        value: "molecular-biology",
        text: "molecular biology",
    },
    {
        key: "molecular-engineering",
        value: "molecular-engineering",
        text: "molecular engineering",
    },
    {
        key: "molecular-evolution",
        value: "molecular-evolution",
        text: "molecular evolution",
    },
    {
        key: "molecular-genetics",
        value: "molecular-genetics",
        text: "molecular genetics",
    },
    {
        key: "molecular-neuroscience",
        value: "molecular-neuroscience",
        text: "molecular neuroscience",
    },
    {
        key: "molecular-spintronics",
        value: "molecular-spintronics",
        text: "molecular spintronics",
    },
    {
        key: "monetary-and-finances",
        value: "monetary-and-finances",
        text: "monetary and finances",
    },
    {
        key: "mortality",
        value: "mortality",
        text: "mortality",
    },
    {
        key: "multidrug-resistance",
        value: "multidrug-resistance",
        text: "multidrug resistance",
    },
    {
        key: "multiphysics",
        value: "multiphysics",
        text: "multiphysics",
    },
    {
        key: "multiple-sclerosis",
        value: "multiple-sclerosis",
        text: "multiple sclerosis",
    },
    {
        key: "muscular-dystrophies",
        value: "muscular-dystrophies",
        text: "muscular dystrophies",
    },
    {
        key: "musicology",
        value: "musicology",
        text: "musicology",
    },
    {
        key: "muslim-culture",
        value: "muslim-culture",
        text: "muslim culture",
    },
    {
        key: "muslim-societies",
        value: "muslim-societies",
        text: "muslim societies",
    },
    {
        key: "mutation",
        value: "mutation",
        text: "mutation",
    },
    {
        key: "mycology",
        value: "mycology",
        text: "mycology",
    },
    {
        key: "nano-materials",
        value: "nano-materials",
        text: "nano-materials",
    },
    {
        key: "nano-processes",
        value: "nano-processes",
        text: "nano-processes",
    },
    {
        key: "nanocomposites",
        value: "nanocomposites",
        text: "nanocomposites",
    },
    {
        key: "nanocrystals",
        value: "nanocrystals",
        text: "nanocrystals",
    },
    {
        key: "nanoelectromechanical-systems",
        value: "nanoelectromechanical-systems",
        text: "nanoelectromechanical systems",
    },
    {
        key: "nanoelectronics",
        value: "nanoelectronics",
        text: "nanoelectronics",
    },
    {
        key: "nanomedicine",
        value: "nanomedicine",
        text: "nanomedicine",
    },
    {
        key: "nanophotonics",
        value: "nanophotonics",
        text: "nanophotonics",
    },
    {
        key: "nanotechnology",
        value: "nanotechnology",
        text: "nanotechnology",
    },
    {
        key: "national-state-of-emergency",
        value: "national-state-of-emergency",
        text: "national state of emergency",
    },
    {
        key: "natural-disasters",
        value: "natural-disasters",
        text: "natural disasters",
    },
    {
        key: "natural-gas",
        value: "natural-gas",
        text: "natural gas",
    },
    {
        key: "natural-language-processing",
        value: "natural-language-processing",
        text: "natural language processing",
    },
    {
        key: "natural-resources-management",
        value: "natural-resources-management",
        text: "natural resources management",
    },
    {
        key: "natural-satellites",
        value: "natural-satellites",
        text: "natural satellites",
    },
    {
        key: "naval-engineering",
        value: "naval-engineering",
        text: "naval engineering",
    },
    {
        key: "navigation-systems",
        value: "navigation-systems",
        text: "navigation systems",
    },
    {
        key: "nephrology",
        value: "nephrology",
        text: "nephrology",
    },
    {
        key: "network-security",
        value: "network-security",
        text: "network security",
    },
    {
        key: "neurobiology",
        value: "neurobiology",
        text: "neurobiology",
    },
    {
        key: "neurology",
        value: "neurology",
        text: "neurology",
    },
    {
        key: "neutrinos",
        value: "neutrinos",
        text: "neutrinos",
    },
    {
        key: "neutron-stars",
        value: "neutron-stars",
        text: "neutron stars",
    },
    {
        key: "noble-gases",
        value: "noble-gases",
        text: "noble gases",
    },
    {
        key: "non-relational-databases",
        value: "non-relational-databases",
        text: "non-relational databases",
    },
    {
        key: "nongovernmental-organizations",
        value: "nongovernmental-organizations",
        text: "nongovernmental organizations",
    },
    {
        key: "nonlinear-optics",
        value: "nonlinear-optics",
        text: "nonlinear optics",
    },
    {
        key: "north-atlantic-oscillation",
        value: "north-atlantic-oscillation",
        text: "north atlantic oscillation",
    },
    {
        key: "nuclear-chemistry",
        value: "nuclear-chemistry",
        text: "nuclear chemistry",
    },
    {
        key: "nuclear-decay",
        value: "nuclear-decay",
        text: "nuclear decay",
    },
    {
        key: "nuclear-energy",
        value: "nuclear-energy",
        text: "nuclear energy",
    },
    {
        key: "nuclear-engineering",
        value: "nuclear-engineering",
        text: "nuclear engineering",
    },
    {
        key: "nuclear-fission",
        value: "nuclear-fission",
        text: "nuclear fission",
    },
    {
        key: "nuclear-fusion",
        value: "nuclear-fusion",
        text: "nuclear fusion",
    },
    {
        key: "nuclear-medicine",
        value: "nuclear-medicine",
        text: "nuclear medicine",
    },
    {
        key: "nuclear-physics",
        value: "nuclear-physics",
        text: "nuclear physics",
    },
    {
        key: "nuclear-waste-management",
        value: "nuclear-waste-management",
        text: "nuclear waste management",
    },
    {
        key: "nucleic-acids",
        value: "nucleic-acids",
        text: "nucleic acids",
    },
    {
        key: "nucleotides",
        value: "nucleotides",
        text: "nucleotides",
    },
    {
        key: "numerical-analysis",
        value: "numerical-analysis",
        text: "numerical analysis",
    },
    {
        key: "nursing",
        value: "nursing",
        text: "nursing",
    },
    {
        key: "nutrition",
        value: "nutrition",
        text: "nutrition",
    },
    {
        key: "obesity",
        value: "obesity",
        text: "obesity",
    },
    {
        key: "observational-astronomy",
        value: "observational-astronomy",
        text: "observational astronomy",
    },
    {
        key: "obsessive-compulsive-disorder",
        value: "obsessive-compulsive-disorder",
        text: "obsessive-compulsive disorder",
    },
    {
        key: "obstetrics",
        value: "obstetrics",
        text: "obstetrics",
    },
    {
        key: "occupational-health",
        value: "occupational-health",
        text: "occupational health",
    },
    {
        key: "ocean-chemistry",
        value: "ocean-chemistry",
        text: "ocean chemistry",
    },
    {
        key: "ocean-engineering",
        value: "ocean-engineering",
        text: "ocean engineering",
    },
    {
        key: "oceanography",
        value: "oceanography",
        text: "oceanography",
    },
    {
        key: "odontology",
        value: "odontology",
        text: "odontology",
    },
    {
        key: "oilseeds",
        value: "oilseeds",
        text: "oilseeds",
    },
    {
        key: "oncology",
        value: "oncology",
        text: "oncology",
    },
    {
        key: "ontology",
        value: "ontology",
        text: "ontology",
    },
    {
        key: "operating-systems",
        value: "operating-systems",
        text: "operating systems",
    },
    {
        key: "ophthalmology",
        value: "ophthalmology",
        text: "ophthalmology",
    },
    {
        key: "optical-astronomy",
        value: "optical-astronomy",
        text: "optical astronomy",
    },
    {
        key: "optical-networks",
        value: "optical-networks",
        text: "optical networks",
    },
    {
        key: "optical-sensors",
        value: "optical-sensors",
        text: "optical sensors",
    },
    {
        key: "optics",
        value: "optics",
        text: "optics",
    },
    {
        key: "optoelectronics",
        value: "optoelectronics",
        text: "optoelectronics",
    },
    {
        key: "organ-on-a-chip",
        value: "organ-on-a-chip",
        text: "organ on a chip",
    },
    {
        key: "organic-acids",
        value: "organic-acids",
        text: "organic acids",
    },
    {
        key: "organic-chemistry",
        value: "organic-chemistry",
        text: "organic chemistry",
    },
    {
        key: "organic-geochemistry",
        value: "organic-geochemistry",
        text: "organic geochemistry",
    },
    {
        key: "organic-reactions",
        value: "organic-reactions",
        text: "organic reactions",
    },
    {
        key: "organohalogen-compounds",
        value: "organohalogen-compounds",
        text: "organohalogen compounds",
    },
    {
        key: "organometallic-chemistry",
        value: "organometallic-chemistry",
        text: "organometallic chemistry",
    },
    {
        key: "ornithology",
        value: "ornithology",
        text: "ornithology",
    },
    {
        key: "orthodontics",
        value: "orthodontics",
        text: "orthodontics",
    },
    {
        key: "orthopaedics",
        value: "orthopaedics",
        text: "orthopaedics",
    },
    {
        key: "other-agricultural-sciences",
        value: "other-agricultural-sciences",
        text: "other agricultural sciences",
    },
    {
        key: "other-biological-topics",
        value: "other-biological-topics",
        text: "other biological topics",
    },
    {
        key: "other-engineering-and-technologies",
        value: "other-engineering-and-technologies",
        text: "other engineering and technologies",
    },
    {
        key: "other-humanities",
        value: "other-humanities",
        text: "other humanities",
    },
    {
        key: "other-medical-sciences",
        value: "other-medical-sciences",
        text: "other medical sciences",
    },
    {
        key: "other-natural-sciences",
        value: "other-natural-sciences",
        text: "other natural sciences",
    },
    {
        key: "other-social-sciences",
        value: "other-social-sciences",
        text: "other social sciences",
    },
    {
        key: "otorhinolaryngology",
        value: "otorhinolaryngology",
        text: "otorhinolaryngology",
    },
    {
        key: "ozone-depletion",
        value: "ozone-depletion",
        text: "ozone depletion",
    },
    {
        key: "paediatric-cardiology",
        value: "paediatric-cardiology",
        text: "paediatric cardiology",
    },
    {
        key: "paediatrics",
        value: "paediatrics",
        text: "paediatrics",
    },
    {
        key: "palaeontology",
        value: "palaeontology",
        text: "palaeontology",
    },
    {
        key: "paleoanthropology",
        value: "paleoanthropology",
        text: "paleoanthropology",
    },
    {
        key: "paleoclimatology",
        value: "paleoclimatology",
        text: "paleoclimatology",
    },
    {
        key: "paleoecology",
        value: "paleoecology",
        text: "paleoecology",
    },
    {
        key: "palynology",
        value: "palynology",
        text: "palynology",
    },
    {
        key: "pancreatic-cancer",
        value: "pancreatic-cancer",
        text: "pancreatic cancer",
    },
    {
        key: "pandemic-risks",
        value: "pandemic-risks",
        text: "pandemic risks",
    },
    {
        key: "pandemics",
        value: "pandemics",
        text: "pandemics",
    },
    {
        key: "parasitology",
        value: "parasitology",
        text: "parasitology",
    },
    {
        key: "parkinson",
        value: "parkinson",
        text: "parkinson",
    },
    {
        key: "partial-differential-equations",
        value: "partial-differential-equations",
        text: "partial differential equations",
    },
    {
        key: "particle-accelerator",
        value: "particle-accelerator",
        text: "particle accelerator",
    },
    {
        key: "particle-physics",
        value: "particle-physics",
        text: "particle physics",
    },
    {
        key: "pathology",
        value: "pathology",
        text: "pathology",
    },
    {
        key: "pathophysiology",
        value: "pathophysiology",
        text: "pathophysiology",
    },
    {
        key: "pattern-recognition",
        value: "pattern-recognition",
        text: "pattern recognition",
    },
    {
        key: "pedagogy",
        value: "pedagogy",
        text: "pedagogy",
    },
    {
        key: "pedology",
        value: "pedology",
        text: "pedology",
    },
    {
        key: "penology",
        value: "penology",
        text: "penology",
    },
    {
        key: "performing-arts",
        value: "performing-arts",
        text: "performing arts",
    },
    {
        key: "periodontics",
        value: "periodontics",
        text: "periodontics",
    },
    {
        key: "peripheral-vascular-disease",
        value: "peripheral-vascular-disease",
        text: "peripheral vascular disease",
    },
    {
        key: "personalized-medicine",
        value: "personalized-medicine",
        text: "personalized medicine",
    },
    {
        key: "petrography",
        value: "petrography",
        text: "petrography",
    },
    {
        key: "petroleum",
        value: "petroleum",
        text: "petroleum",
    },
    {
        key: "petrology",
        value: "petrology",
        text: "petrology",
    },
    {
        key: "pharmaceutical-drugs",
        value: "pharmaceutical-drugs",
        text: "pharmaceutical drugs",
    },
    {
        key: "pharmacokinetics",
        value: "pharmacokinetics",
        text: "pharmacokinetics",
    },
    {
        key: "pharmacology-and-pharmacy",
        value: "pharmacology-and-pharmacy",
        text: "pharmacology and pharmacy",
    },
    {
        key: "philosophy",
        value: "philosophy",
        text: "philosophy",
    },
    {
        key: "philosophy-of-language",
        value: "philosophy-of-language",
        text: "philosophy of language",
    },
    {
        key: "philosophy,-ethics-and-religion",
        value: "philosophy,-ethics-and-religion",
        text: "philosophy, ethics and religion",
    },
    {
        key: "phonetics",
        value: "phonetics",
        text: "phonetics",
    },
    {
        key: "phonology",
        value: "phonology",
        text: "phonology",
    },
    {
        key: "photocatalysis",
        value: "photocatalysis",
        text: "photocatalysis",
    },
    {
        key: "photochemistry",
        value: "photochemistry",
        text: "photochemistry",
    },
    {
        key: "photons",
        value: "photons",
        text: "photons",
    },
    {
        key: "photovoltaic",
        value: "photovoltaic",
        text: "photovoltaic",
    },
    {
        key: "phycology",
        value: "phycology",
        text: "phycology",
    },
    {
        key: "physical-anthropology",
        value: "physical-anthropology",
        text: "physical anthropology",
    },
    {
        key: "physical-chemistry",
        value: "physical-chemistry",
        text: "physical chemistry",
    },
    {
        key: "physical-cosmology",
        value: "physical-cosmology",
        text: "physical cosmology",
    },
    {
        key: "physical-geography",
        value: "physical-geography",
        text: "physical geography",
    },
    {
        key: "physical-oceanography",
        value: "physical-oceanography",
        text: "physical oceanography",
    },
    {
        key: "physical-sciences",
        value: "physical-sciences",
        text: "physical sciences",
    },
    {
        key: "physiology",
        value: "physiology",
        text: "physiology",
    },
    {
        key: "physiotherapy",
        value: "physiotherapy",
        text: "physiotherapy",
    },
    {
        key: "phytoremediation",
        value: "phytoremediation",
        text: "phytoremediation",
    },
    {
        key: "piezoelectrics",
        value: "piezoelectrics",
        text: "piezoelectrics",
    },
    {
        key: "planetary-geology",
        value: "planetary-geology",
        text: "planetary geology",
    },
    {
        key: "planetary-sciences",
        value: "planetary-sciences",
        text: "planetary sciences",
    },
    {
        key: "planets",
        value: "planets",
        text: "planets",
    },
    {
        key: "plant-breeding",
        value: "plant-breeding",
        text: "plant breeding",
    },
    {
        key: "plant-cloning",
        value: "plant-cloning",
        text: "plant cloning",
    },
    {
        key: "plant-protection",
        value: "plant-protection",
        text: "plant protection",
    },
    {
        key: "plasma-physics",
        value: "plasma-physics",
        text: "plasma physics",
    },
    {
        key: "plate-tectonics",
        value: "plate-tectonics",
        text: "plate tectonics",
    },
    {
        key: "pneumology",
        value: "pneumology",
        text: "pneumology",
    },
    {
        key: "political-communication",
        value: "political-communication",
        text: "political communication",
    },
    {
        key: "political-economy",
        value: "political-economy",
        text: "political economy",
    },
    {
        key: "political-philosophy",
        value: "political-philosophy",
        text: "political philosophy",
    },
    {
        key: "political-policies",
        value: "political-policies",
        text: "political policies",
    },
    {
        key: "political-sciences",
        value: "political-sciences",
        text: "political sciences",
    },
    {
        key: "political-transitions",
        value: "political-transitions",
        text: "political transitions",
    },
    {
        key: "political-violence",
        value: "political-violence",
        text: "political violence",
    },
    {
        key: "pollution",
        value: "pollution",
        text: "pollution",
    },
    {
        key: "polyhydroxyalkanoates",
        value: "polyhydroxyalkanoates",
        text: "polyhydroxyalkanoates",
    },
    {
        key: "polylactic-acid",
        value: "polylactic-acid",
        text: "polylactic acid",
    },
    {
        key: "polymer-sciences",
        value: "polymer-sciences",
        text: "polymer sciences",
    },
    {
        key: "polyurethane",
        value: "polyurethane",
        text: "polyurethane",
    },
    {
        key: "popular-music-studies",
        value: "popular-music-studies",
        text: "popular music studies",
    },
    {
        key: "port-and-harbor-engineering",
        value: "port-and-harbor-engineering",
        text: "port and harbor engineering",
    },
    {
        key: "post-transition-metals",
        value: "post-transition-metals",
        text: "post-transition metals",
    },
    {
        key: "postnatal-care",
        value: "postnatal-care",
        text: "postnatal care",
    },
    {
        key: "posttraumatic-stress-disorder",
        value: "posttraumatic-stress-disorder",
        text: "posttraumatic stress disorder",
    },
    {
        key: "power-engineering",
        value: "power-engineering",
        text: "power engineering",
    },
    {
        key: "prehistory",
        value: "prehistory",
        text: "prehistory",
    },
    {
        key: "primatology",
        value: "primatology",
        text: "primatology",
    },
    {
        key: "prime-numbers",
        value: "prime-numbers",
        text: "prime numbers",
    },
    {
        key: "product-engineering",
        value: "product-engineering",
        text: "product engineering",
    },
    {
        key: "production-economics",
        value: "production-economics",
        text: "production economics",
    },
    {
        key: "productivity",
        value: "productivity",
        text: "productivity",
    },
    {
        key: "prokaryotic-genomes",
        value: "prokaryotic-genomes",
        text: "prokaryotic genomes",
    },
    {
        key: "prostate-cancer",
        value: "prostate-cancer",
        text: "prostate cancer",
    },
    {
        key: "protein-folding",
        value: "protein-folding",
        text: "protein folding",
    },
    {
        key: "proteins",
        value: "proteins",
        text: "proteins",
    },
    {
        key: "proteomics",
        value: "proteomics",
        text: "proteomics",
    },
    {
        key: "protozoology",
        value: "protozoology",
        text: "protozoology",
    },
    {
        key: "psychiatry",
        value: "psychiatry",
        text: "psychiatry",
    },
    {
        key: "psychoanalysis",
        value: "psychoanalysis",
        text: "psychoanalysis",
    },
    {
        key: "psycholinguistics",
        value: "psycholinguistics",
        text: "psycholinguistics",
    },
    {
        key: "psychology",
        value: "psychology",
        text: "psychology",
    },
    {
        key: "psychotherapy",
        value: "psychotherapy",
        text: "psychotherapy",
    },
    {
        key: "public-administration",
        value: "public-administration",
        text: "public administration",
    },
    {
        key: "public-health",
        value: "public-health",
        text: "public health",
    },
    {
        key: "public-libraries",
        value: "public-libraries",
        text: "public libraries",
    },
    {
        key: "public-policies",
        value: "public-policies",
        text: "public policies",
    },
    {
        key: "public-services",
        value: "public-services",
        text: "public services",
    },
    {
        key: "public-transport",
        value: "public-transport",
        text: "public transport",
    },
    {
        key: "pulsed-lasers",
        value: "pulsed-lasers",
        text: "pulsed lasers",
    },
    {
        key: "pure-mathematics",
        value: "pure-mathematics",
        text: "pure mathematics",
    },
    {
        key: "quantitative-analysis",
        value: "quantitative-analysis",
        text: "quantitative analysis",
    },
    {
        key: "quantum-chemistry",
        value: "quantum-chemistry",
        text: "quantum chemistry",
    },
    {
        key: "quantum-computers",
        value: "quantum-computers",
        text: "quantum computers",
    },
    {
        key: "quantum-field-theory",
        value: "quantum-field-theory",
        text: "quantum field theory",
    },
    {
        key: "quantum-gases",
        value: "quantum-gases",
        text: "quantum gases",
    },
    {
        key: "quantum-optics",
        value: "quantum-optics",
        text: "quantum optics",
    },
    {
        key: "quantum-physics",
        value: "quantum-physics",
        text: "quantum physics",
    },
    {
        key: "quarks",
        value: "quarks",
        text: "quarks",
    },
    {
        key: "racial-inequality",
        value: "racial-inequality",
        text: "racial inequality",
    },
    {
        key: "radar",
        value: "radar",
        text: "radar",
    },
    {
        key: "radiation-chemistry",
        value: "radiation-chemistry",
        text: "radiation chemistry",
    },
    {
        key: "radio-and-television",
        value: "radio-and-television",
        text: "radio and television",
    },
    {
        key: "radio-astronomy",
        value: "radio-astronomy",
        text: "radio astronomy",
    },
    {
        key: "radio-frequency",
        value: "radio-frequency",
        text: "radio frequency",
    },
    {
        key: "radio-technology",
        value: "radio-technology",
        text: "radio technology",
    },
    {
        key: "radiochemistry",
        value: "radiochemistry",
        text: "radiochemistry",
    },
    {
        key: "radiology",
        value: "radiology",
        text: "radiology",
    },
    {
        key: "railroad-engineering",
        value: "railroad-engineering",
        text: "railroad engineering",
    },
    {
        key: "recycling",
        value: "recycling",
        text: "recycling",
    },
    {
        key: "regional-human-rights",
        value: "regional-human-rights",
        text: "regional human rights",
    },
    {
        key: "reinforcement-learning",
        value: "reinforcement-learning",
        text: "reinforcement learning",
    },
    {
        key: "relational-databases",
        value: "relational-databases",
        text: "relational databases",
    },
    {
        key: "relativistic-mechanics",
        value: "relativistic-mechanics",
        text: "relativistic mechanics",
    },
    {
        key: "religions",
        value: "religions",
        text: "religions",
    },
    {
        key: "remanufacturing",
        value: "remanufacturing",
        text: "remanufacturing",
    },
    {
        key: "remote-sensing",
        value: "remote-sensing",
        text: "remote sensing",
    },
    {
        key: "renal-dialysis",
        value: "renal-dialysis",
        text: "renal dialysis",
    },
    {
        key: "renewable-energy",
        value: "renewable-energy",
        text: "renewable energy",
    },
    {
        key: "reproductive-biology",
        value: "reproductive-biology",
        text: "reproductive biology",
    },
    {
        key: "reproductive-medicine",
        value: "reproductive-medicine",
        text: "reproductive medicine",
    },
    {
        key: "retinopathy",
        value: "retinopathy",
        text: "retinopathy",
    },
    {
        key: "reverse-osmosis",
        value: "reverse-osmosis",
        text: "reverse osmosis",
    },
    {
        key: "revolutions",
        value: "revolutions",
        text: "revolutions",
    },
    {
        key: "rheumatology",
        value: "rheumatology",
        text: "rheumatology",
    },
    {
        key: "riots",
        value: "riots",
        text: "riots",
    },
    {
        key: "robotic-surgery",
        value: "robotic-surgery",
        text: "robotic surgery",
    },
    {
        key: "robotics",
        value: "robotics",
        text: "robotics",
    },
    {
        key: "root-crops",
        value: "root-crops",
        text: "root crops",
    },
    {
        key: "rotorcraft",
        value: "rotorcraft",
        text: "rotorcraft",
    },
    {
        key: "satellite-navigation-system",
        value: "satellite-navigation-system",
        text: "satellite navigation system",
    },
    {
        key: "satellite-radio",
        value: "satellite-radio",
        text: "satellite radio",
    },
    {
        key: "satellite-technology",
        value: "satellite-technology",
        text: "satellite technology",
    },
    {
        key: "scanning-tunneling-microscopy",
        value: "scanning-tunneling-microscopy",
        text: "scanning tunneling microscopy",
    },
    {
        key: "schizophrenia",
        value: "schizophrenia",
        text: "schizophrenia",
    },
    {
        key: "science-and-technology-studies",
        value: "science-and-technology-studies",
        text: "science and technology studies",
    },
    {
        key: "science-fiction",
        value: "science-fiction",
        text: "science fiction",
    },
    {
        key: "sea-vessels",
        value: "sea-vessels",
        text: "sea vessels",
    },
    {
        key: "sedimentary-petrology",
        value: "sedimentary-petrology",
        text: "sedimentary petrology",
    },
    {
        key: "sedimentology",
        value: "sedimentology",
        text: "sedimentology",
    },
    {
        key: "seismic-loading",
        value: "seismic-loading",
        text: "seismic loading",
    },
    {
        key: "seismic-risk-management",
        value: "seismic-risk-management",
        text: "seismic risk management",
    },
    {
        key: "seismology",
        value: "seismology",
        text: "seismology",
    },
    {
        key: "semantic-web",
        value: "semantic-web",
        text: "semantic web",
    },
    {
        key: "semiconductivity",
        value: "semiconductivity",
        text: "semiconductivity",
    },
    {
        key: "sensors",
        value: "sensors",
        text: "sensors",
    },
    {
        key: "separation-technologies",
        value: "separation-technologies",
        text: "separation technologies",
    },
    {
        key: "sexual-health",
        value: "sexual-health",
        text: "sexual health",
    },
    {
        key: "sexual-violence",
        value: "sexual-violence",
        text: "sexual violence",
    },
    {
        key: "sign-language",
        value: "sign-language",
        text: "sign language",
    },
    {
        key: "signal-processing",
        value: "signal-processing",
        text: "signal processing",
    },
    {
        key: "silicene",
        value: "silicene",
        text: "silicene",
    },
    {
        key: "silviculture",
        value: "silviculture",
        text: "silviculture",
    },
    {
        key: "simulation-software",
        value: "simulation-software",
        text: "simulation software",
    },
    {
        key: "skin-cancer",
        value: "skin-cancer",
        text: "skin cancer",
    },
    {
        key: "sleep-disorders",
        value: "sleep-disorders",
        text: "sleep disorders",
    },
    {
        key: "smart-cities",
        value: "smart-cities",
        text: "smart cities",
    },
    {
        key: "smart-sensors",
        value: "smart-sensors",
        text: "smart sensors",
    },
    {
        key: "social-anthropology",
        value: "social-anthropology",
        text: "social anthropology",
    },
    {
        key: "social-aspects-of-transport",
        value: "social-aspects-of-transport",
        text: "social aspects of transport",
    },
    {
        key: "social-biomedical-sciences",
        value: "social-biomedical-sciences",
        text: "social biomedical sciences",
    },
    {
        key: "social-geography",
        value: "social-geography",
        text: "social geography",
    },
    {
        key: "social-inequalities",
        value: "social-inequalities",
        text: "social inequalities",
    },
    {
        key: "social-issues",
        value: "social-issues",
        text: "social issues",
    },
    {
        key: "social-psychology",
        value: "social-psychology",
        text: "social psychology",
    },
    {
        key: "social-work",
        value: "social-work",
        text: "social work",
    },
    {
        key: "sociology",
        value: "sociology",
        text: "sociology",
    },
    {
        key: "soft-matter-physics",
        value: "soft-matter-physics",
        text: "soft matter physics",
    },
    {
        key: "soft-robotics",
        value: "soft-robotics",
        text: "soft robotics",
    },
    {
        key: "software",
        value: "software",
        text: "software",
    },
    {
        key: "software-applications",
        value: "software-applications",
        text: "software applications",
    },
    {
        key: "software-development",
        value: "software-development",
        text: "software development",
    },
    {
        key: "soil-sciences",
        value: "soil-sciences",
        text: "soil sciences",
    },
    {
        key: "solar-astronomy",
        value: "solar-astronomy",
        text: "solar astronomy",
    },
    {
        key: "solar-energy",
        value: "solar-energy",
        text: "solar energy",
    },
    {
        key: "solar-physics",
        value: "solar-physics",
        text: "solar physics",
    },
    {
        key: "solar-radiation",
        value: "solar-radiation",
        text: "solar radiation",
    },
    {
        key: "solar-thermal",
        value: "solar-thermal",
        text: "solar thermal",
    },
    {
        key: "solid-mechanics",
        value: "solid-mechanics",
        text: "solid mechanics",
    },
    {
        key: "solid-state-physics",
        value: "solid-state-physics",
        text: "solid-state physics",
    },
    {
        key: "space-exploration",
        value: "space-exploration",
        text: "space exploration",
    },
    {
        key: "spacecraft",
        value: "spacecraft",
        text: "spacecraft",
    },
    {
        key: "special-education",
        value: "special-education",
        text: "special education",
    },
    {
        key: "spectroscopy",
        value: "spectroscopy",
        text: "spectroscopy",
    },
    {
        key: "speech-language-pathology",
        value: "speech-language-pathology",
        text: "speech-language pathology",
    },
    {
        key: "speleology",
        value: "speleology",
        text: "speleology",
    },
    {
        key: "spintronics",
        value: "spintronics",
        text: "spintronics",
    },
    {
        key: "sport-and-fitness-sciences",
        value: "sport-and-fitness-sciences",
        text: "sport and fitness sciences",
    },
    {
        key: "squamous-cell-carcinoma",
        value: "squamous-cell-carcinoma",
        text: "squamous cell carcinoma",
    },
    {
        key: "statistical-mechanics",
        value: "statistical-mechanics",
        text: "statistical mechanics",
    },
    {
        key: "statistics-and-probability",
        value: "statistics-and-probability",
        text: "statistics and probability",
    },
    {
        key: "stellar-astronomy",
        value: "stellar-astronomy",
        text: "stellar astronomy",
    },
    {
        key: "stem-cells",
        value: "stem-cells",
        text: "stem cells",
    },
    {
        key: "strabismus",
        value: "strabismus",
        text: "strabismus",
    },
    {
        key: "string-theory",
        value: "string-theory",
        text: "string theory",
    },
    {
        key: "stroke",
        value: "stroke",
        text: "stroke",
    },
    {
        key: "structural-biology",
        value: "structural-biology",
        text: "structural biology",
    },
    {
        key: "structural-engineering",
        value: "structural-engineering",
        text: "structural engineering",
    },
    {
        key: "structural-health-monitoring",
        value: "structural-health-monitoring",
        text: "structural health monitoring",
    },
    {
        key: "substance-abuse",
        value: "substance-abuse",
        text: "substance abuse",
    },
    {
        key: "subtractive-manufacturing",
        value: "subtractive-manufacturing",
        text: "subtractive manufacturing",
    },
    {
        key: "super-resolution-microscopy",
        value: "super-resolution-microscopy",
        text: "super resolution microscopy",
    },
    {
        key: "super-earths",
        value: "super-earths",
        text: "super-Earths",
    },
    {
        key: "supercomputers",
        value: "supercomputers",
        text: "supercomputers",
    },
    {
        key: "superconductivity",
        value: "superconductivity",
        text: "superconductivity",
    },
    {
        key: "supernova",
        value: "supernova",
        text: "supernova",
    },
    {
        key: "supervised-learning",
        value: "supervised-learning",
        text: "supervised learning",
    },
    {
        key: "surgery",
        value: "surgery",
        text: "surgery",
    },
    {
        key: "surgical-procedures",
        value: "surgical-procedures",
        text: "surgical procedures",
    },
    {
        key: "surgical-specialties",
        value: "surgical-specialties",
        text: "surgical specialties",
    },
    {
        key: "sustainability-sciences",
        value: "sustainability-sciences",
        text: "sustainability sciences",
    },
    {
        key: "sustainable-agriculture",
        value: "sustainable-agriculture",
        text: "sustainable agriculture",
    },
    {
        key: "sustainable-architecture",
        value: "sustainable-architecture",
        text: "sustainable architecture",
    },
    {
        key: "sustainable-building",
        value: "sustainable-building",
        text: "sustainable building",
    },
    {
        key: "sustainable-economy",
        value: "sustainable-economy",
        text: "sustainable economy",
    },
    {
        key: "sustainable-transport",
        value: "sustainable-transport",
        text: "sustainable transport",
    },
    {
        key: "swarm-robotics",
        value: "swarm-robotics",
        text: "swarm robotics",
    },
    {
        key: "symplectic-topology",
        value: "symplectic-topology",
        text: "symplectic topology",
    },
    {
        key: "synthetic-biology",
        value: "synthetic-biology",
        text: "synthetic biology",
    },
    {
        key: "synthetic-dyes",
        value: "synthetic-dyes",
        text: "synthetic dyes",
    },
    {
        key: "synthetic-fuels",
        value: "synthetic-fuels",
        text: "synthetic fuels",
    },
    {
        key: "system-software",
        value: "system-software",
        text: "system software",
    },
    {
        key: "taxation",
        value: "taxation",
        text: "taxation",
    },
    {
        key: "telecommunications",
        value: "telecommunications",
        text: "telecommunications",
    },
    {
        key: "telecommunications-networks",
        value: "telecommunications-networks",
        text: "telecommunications networks",
    },
    {
        key: "teleology",
        value: "teleology",
        text: "teleology",
    },
    {
        key: "terrorism",
        value: "terrorism",
        text: "terrorism",
    },
    {
        key: "textiles",
        value: "textiles",
        text: "textiles",
    },
    {
        key: "theoretical-physics",
        value: "theoretical-physics",
        text: "theoretical physics",
    },
    {
        key: "thermochemistry",
        value: "thermochemistry",
        text: "thermochemistry",
    },
    {
        key: "thermodynamic-engineering",
        value: "thermodynamic-engineering",
        text: "thermodynamic engineering",
    },
    {
        key: "thermodynamics",
        value: "thermodynamics",
        text: "thermodynamics",
    },
    {
        key: "tidal-energy",
        value: "tidal-energy",
        text: "tidal energy",
    },
    {
        key: "tissue-engineering",
        value: "tissue-engineering",
        text: "tissue engineering",
    },
    {
        key: "topology",
        value: "topology",
        text: "topology",
    },
    {
        key: "toxicology",
        value: "toxicology",
        text: "toxicology",
    },
    {
        key: "transfer-learning",
        value: "transfer-learning",
        text: "transfer learning",
    },
    {
        key: "transition-metals",
        value: "transition-metals",
        text: "transition metals",
    },
    {
        key: "transplantation",
        value: "transplantation",
        text: "transplantation",
    },
    {
        key: "transport",
        value: "transport",
        text: "transport",
    },
    {
        key: "transport-layer",
        value: "transport-layer",
        text: "transport layer",
    },
    {
        key: "transport-planning",
        value: "transport-planning",
        text: "transport planning",
    },
    {
        key: "transportation-engineering",
        value: "transportation-engineering",
        text: "transportation engineering",
    },
    {
        key: "tribology",
        value: "tribology",
        text: "tribology",
    },
    {
        key: "tropical-medicine",
        value: "tropical-medicine",
        text: "tropical medicine",
    },
    {
        key: "troposphere",
        value: "troposphere",
        text: "troposphere",
    },
    {
        key: "tuberculosis",
        value: "tuberculosis",
        text: "tuberculosis",
    },
    {
        key: "two-dimensional-nanostructures",
        value: "two-dimensional-nanostructures",
        text: "two-dimensional nanostructures",
    },
    {
        key: "ultrafast-lasers",
        value: "ultrafast-lasers",
        text: "ultrafast lasers",
    },
    {
        key: "ultrasound",
        value: "ultrasound",
        text: "ultrasound",
    },
    {
        key: "ultraviolet-lasers",
        value: "ultraviolet-lasers",
        text: "ultraviolet lasers",
    },
    {
        key: "underwater-archaeology",
        value: "underwater-archaeology",
        text: "underwater archaeology",
    },
    {
        key: "unemployment",
        value: "unemployment",
        text: "unemployment",
    },
    {
        key: "unsupervised-learning",
        value: "unsupervised-learning",
        text: "unsupervised learning",
    },
    {
        key: "urban-drainage",
        value: "urban-drainage",
        text: "urban drainage",
    },
    {
        key: "urban-engineering",
        value: "urban-engineering",
        text: "urban engineering",
    },
    {
        key: "urban-horticulture",
        value: "urban-horticulture",
        text: "urban horticulture",
    },
    {
        key: "urban-studies",
        value: "urban-studies",
        text: "urban studies",
    },
    {
        key: "urology",
        value: "urology",
        text: "urology",
    },
    {
        key: "vaccines",
        value: "vaccines",
        text: "vaccines",
    },
    {
        key: "vascular-diseases",
        value: "vascular-diseases",
        text: "vascular diseases",
    },
    {
        key: "vegetable-growing",
        value: "vegetable-growing",
        text: "vegetable growing",
    },
    {
        key: "vehicle-engineering",
        value: "vehicle-engineering",
        text: "vehicle engineering",
    },
    {
        key: "venereal-diseases",
        value: "venereal-diseases",
        text: "venereal diseases",
    },
    {
        key: "veterinary-sciences",
        value: "veterinary-sciences",
        text: "veterinary sciences",
    },
    {
        key: "video-games",
        value: "video-games",
        text: "video games",
    },
    {
        key: "viral-genomes",
        value: "viral-genomes",
        text: "viral genomes",
    },
    {
        key: "virology",
        value: "virology",
        text: "virology",
    },
    {
        key: "virtual-reality",
        value: "virtual-reality",
        text: "virtual reality",
    },
    {
        key: "virus-mutation",
        value: "virus-mutation",
        text: "virus mutation",
    },
    {
        key: "visual-arts",
        value: "visual-arts",
        text: "visual arts",
    },
    {
        key: "viticulture",
        value: "viticulture",
        text: "viticulture",
    },
    {
        key: "volatile-organic-compounds",
        value: "volatile-organic-compounds",
        text: "volatile organic compounds",
    },
    {
        key: "volcanology",
        value: "volcanology",
        text: "volcanology",
    },
    {
        key: "volumetric-analysis",
        value: "volumetric-analysis",
        text: "volumetric analysis",
    },
    {
        key: "w-bosons",
        value: "w-bosons",
        text: "w bosons",
    },
    {
        key: "waste-management",
        value: "waste-management",
        text: "waste management",
    },
    {
        key: "waste-treatment-processes",
        value: "waste-treatment-processes",
        text: "waste treatment processes",
    },
    {
        key: "wastewater-treatment-processes",
        value: "wastewater-treatment-processes",
        text: "wastewater treatment processes",
    },
    {
        key: "water-engineering",
        value: "water-engineering",
        text: "water engineering",
    },
    {
        key: "water-management",
        value: "water-management",
        text: "water management",
    },
    {
        key: "water-supply-systems",
        value: "water-supply-systems",
        text: "water supply systems",
    },
    {
        key: "water-treatment-processes",
        value: "water-treatment-processes",
        text: "water treatment processes",
    },
    {
        key: "wave-power",
        value: "wave-power",
        text: "wave power",
    },
    {
        key: "wearable-medical-technology",
        value: "wearable-medical-technology",
        text: "wearable medical technology",
    },
    {
        key: "web-accessibility",
        value: "web-accessibility",
        text: "web accessibility",
    },
    {
        key: "web-development",
        value: "web-development",
        text: "web development",
    },
    {
        key: "white-dwarfs",
        value: "white-dwarfs",
        text: "white dwarfs",
    },
    {
        key: "wind-power",
        value: "wind-power",
        text: "wind power",
    },
    {
        key: "women\u2019s-studies",
        value: "women\u2019s-studies",
        text: "women\u2019s studies",
    },
    {
        key: "woodworking",
        value: "woodworking",
        text: "woodworking",
    },
    {
        key: "world-wide-web",
        value: "world-wide-web",
        text: "world wide web",
    },
    {
        key: "x-ray-astronomy",
        value: "x-ray-astronomy",
        text: "x-ray astronomy",
    },
    {
        key: "x-ray-radiography",
        value: "x-ray-radiography",
        text: "x-ray radiography",
    },
    {
        key: "z-bosons",
        value: "z-bosons",
        text: "z bosons",
    },
    {
        key: "zoology",
        value: "zoology",
        text: "zoology",
    },
    {
        key: "zoonosis",
        value: "zoonosis",
        text: "zoonosis",
    },
];
